import Feature from 'Services/Feature';
import { DocFormulaFactory } from 'Services/Documents/docFormulaFactory';
import Big from "big.js";

window.DocFormv2 = {

	numformat : {'name':"", 'currency':"", 'decimals':"", 'thousands':"", 'currencypos':"", 'position':""},
	pointformat : {'name':"", 'currency':"", 'decimals':".", 'thousands':"", 'currencypos':"", 'position':""},
	doctype : null,
	docid : null,
	docDestockOn : null,
	docRestockOn : null,
	restockOnCreditNote: null,

	ecoTax : null,
	vat : null,
	doubleVat : null,

	isTaxesInc : null,
	rateCategory : null,

	hasRelateds : null,
	relatedsAmount : new Big(0),
	subTotal	: 0,

	totalDue : 0,

	columnsDisplay : {
		image		: 'hidden',
		name		: 'col-disabled',
		notes		: 'hidden',
		discount	: 'col-disabled',
		unit		: 'col-disabled',
		tax			: 'col-disabled',
		tax2		: 'col-disabled',
		qt			: 'col-disabled',
		amount		: 'col-disabled'
	},
	isLoaded: false,

	updateRowEInvoicingConformity: function($row) {
		if (!Feature.isEnabled('einvoicing-vat-parameters')) {
			return;
		}

		const selectedTaxOption = $row.find('.tax select option:selected');
		if (!selectedTaxOption.length) {
			return;
		}

		const isEInvoicingCompliant = selectedTaxOption.data('is-einvoicing-compliant');

		if (isEInvoicingCompliant) {
			$row.find('.docform-conformity-warning').hide();
			$row.find('.docform-taxes-button').hide();
		} else {
			$row.find('.docform-conformity-warning').show();
			$row.find('.docform-taxes-button').show();
		}
	},

	init: async function(action, lockform){
		lockform = lockform == undefined ? false : lockform;

		// PREVENT BACKSPACE HISTORY RETURN
		$(document).keydown(function(e) {
			var elementTag	= e.target.nodeName.toLowerCase();
			var $element	= $(e.target);

			if( !$element.is('input')		&&
				elementTag != 'textarea'	&&
				!(elementTag == 'div' && $element.hasClass('redactor_redactor'))) {
				// BACKSPACE
				if (e.keyCode === 8) {
					return false;
				}
			}
		});

		var thirdid = $("#thirdid").val();

		// bind tokenInput
		TokenInput.autoItem("#docForm_searchItem", '', {'includeDecli' : "Y", 'thirdid' : thirdid}, 20 ,
			function(item){
				var itemId = item.id.split('_');
				var declidId = 0;
				if (item.declid !== undefined){
					declidId = item.declid.split('_');
				}
				DocFormv2.addRowFromItemId(itemId[1], declidId[1], thirdid);
				$("#docForm_searchItem").tokenInput("clear");
				$("#token-input-docForm_searchItem").val('');
			}
		);

		if($("#docContext").val() == 'new' || ($("#docContext").val() == 'update' && $('#shipAddressCorp:checked').val() == 'corp')){
			if ($('#shipthirdid').length > 0){
				TokenInput.autoContactListing($('#shipthirdid'), 'third|prospect|supplier', 1, true, undefined , 'Purchases.loadThirdAdr();', 'Purchases.loadThirdAdr();', undefined);
			}
		}

		// Instance cf third & item
		if($("#context").val() != 'new' && $("#docContext").val() != 'new'){
			MyFacture.customForm();
		}

		$('#docForm_searchBc').keypress(function( event ){
			if (event.which === 13) {
			   var searchBc = $('#docForm_searchBc').val();
			   DocFormv2.addRowFromBcValue(searchBc);
			   $('#docForm_searchBc').val('');
			}
		});

		Catalogue.listenDouchetteMode($(document),  "DocFormv2.addRowFromBcValue");

		// init a timer in order to ask user to save his doc after 5
		setTimeout(function(){
			DocFormv2.ask5minSave(action);
		}, 900000);

		// Doc ident
		this.doctype	= $("input[name=doctype]").length > 0 ? $("input[name=doctype]").val() : ($('#doctype').length > 0 ? $('#doctype').val()  : '');
		this.docid		= $("input[name=docid]").length > 0 ? $("input[name=docid]").val() : "";

		// Doc Stock impact
		this.docDestockOn           = $('#docDestockOn').length > 0 ? $("#docDestockOn").val() : "";
		this.docRestockOn           = $('#docRestockOn').length > 0 ? $("#docRestockOn").val() : "";

		this.restockOnCreditNote    = $('#restockOnCreditNote').val();

		// Doc properties
		this.vat			= $('input[name=hasVat]').val() === 'Y';
		this.doubleVat		= $('input[name=hasDoubleVat]').is(':checked');
		this.isTaxesInc		= $('input[name=isTaxesInc]').val() === 'Y';
		this.rateCategory	= $('input[name=rateCategory]').val();
		this.doclang		= $('select[name=docLang]').val();

        /** @type {DocFormula} */
        this.formula = await new DocFormulaFactory().createFormula(document.getElementById('formula_version')?.value);

		this.shopid	= false;

		var urlDocument = document.location.search;
		var conversion = urlDocument.search('from=');

		// Doc created from shops should conserv parent doclayout
		if(!this.docid && conversion != -1 && (!this.shopid || this.shopid == 0)){

			var doctypeDoc = this.doctype;
			var rateCatDoc = this.rateCategory;
			var doclayout  = $('#docForm #doclayout').val();

			var data = {action: "updateLayoutFromNewDoc", doctype: doctypeDoc, docrateCategory : rateCatDoc, doclayout : doclayout};

			MyFacture.post('doc', data, function(data) {

				if(data.layoutID == 0){
					$("#docForm #doclayout").val(data.defaultLayoutCorp);
				}else{
					$("#docForm #doclayout").val(data.layoutID);
				}
			}, "json");

		}

        DocFormv2.ecoTax = {};
        if ($('input[name=ecoTaxId]').length) {
            DocFormv2.ecoTax = {
                id : $('input[name=ecoTaxId]').val(),
                rate : $('input[name=ecoTaxRate]').val(),
                label : $('input[name=ecoTaxLabel]').val()
            };

            if(DocFormv2.ecoTax.rate == ''){
                DocFormv2.ecoTax.rate = 0;
            }
        }

		// Relateds => deposit, payment
		this.hasRelateds = $('input[name=hasRelateds]').val() === 'Y';
		this.relatedsAmount = $('input[name=relatedsAmount]').val() !== '' ? new Big( $('input[name=relatedsAmount]').val()) : this.relatedsAmount;

		// init numberformat from doc inputs
		DocFormv2.getNumFormat(true);

		// init sortable
		$('#formContent').sortable({
			handle : 'a.drag',
			items : '> div',
			opacity : 0.9,
			axis : 'y',
			stop : function(event, ui) {
				DocFormv2.updateSubTotal();
				DocFormv2.updateRank();
				ui.item.css('margin-top',0);
			},
			start: function(event, ui){
				 ui.helper.css('margin-top', $(window).scrollTop());
				 $(document).find('.docQtip').hide();
			},
			cursorAt: { top: 0, left: 0 },
			cursor : 'move',
			placeholder : 'item_list_placeholder',
			forcePlaceholderSize : true ,
			scroll : false,
			containment : 'parent',
			tolerance : 'pointer'
		});

		this.changePayDate();

		DocFormv2.checkForLockedRows();

		// Column display
		$('#docFormPrefs').off().on('click', '.displayColumns', function(){
			DocFormv2.updateDisplayColumn($(this));
		});

		// warehouse access
		var whAccess = new Array();
		$('#warehouseAccessList div').each(function() {
			whAccess.push($(this).attr('whid'));
		});
		if(whAccess.length === 0) {
			$('#stockImpact').prop('checked', false);
		}

		// Compute total
		var options = {
			success:function(data){
				DocFormv2.recordCallback(data);
			},
			dataType:"html"};

		// when we've no warehouse, we don't impact the stock at all.
		if(whAccess.length > 0) {
			options.beforeSubmit = function(){
                if ($('#checkstock').val() === 'Y'){
					return StockDocForm.checkQt();
				} else {
					return true;
				}
			};
		}
		MyForm.prepare("docForm", action+"&action=record", options, true);


		// Bind Live Events on rows & parts of docForm
		$(document).on('change', '#ident', function(){
			$("#identHasChanged").val("1");
		});

		$('#formContent').on('keyup', '.updateRow', function(){
			var id = $(this).closest('div.docrow').attr('id');
			if ($('#'+id).hasClass('shipping')){
				$('#'+id).addClass('shippingPriceFreeze');
				$('#'+id).find('.shippingInfo').hide();
				$('#'+id).find('.shippingInfo.shippingPriceFrozen').show();
			}
		});

		$('#formContent').on('change', '.updateRow', function(){

			var id = $(this).closest('div.docrow').attr('id');
			if(id !== undefined){

				DocFormv2.updateRow('#'+id);
				if($(this).get(0).tagName === 'input' || $(this).get(0).tagName === 'INPUT' ){
					var precisionCustomCurrent = $(this).attr('e_formatnum_precisioncustom');
					$(this).val(NumberFormat.formatToDisplay($(this).val(), DocFormv2.getNumFormat(true), undefined, precisionCustomCurrent));
				}
			}


			if (!$("#"+id).hasClass('shipping')){
				DocFormv2.updateProductsCharacteristics();
			}
		});

		$(document).on('change', '.tauxMarge', function(){
			var id = $(this).closest('div.docrow').attr('id');
			if (id !== undefined){
				DocFormv2.computeMarge('tauxMarge', "#"+id);
			}
		});

		$(document).on('change', '.tauxMarque', function(){
			var id = $(this).closest('div.docrow').attr('id');
			if (id !== undefined){
				DocFormv2.computeMarge('tauxMarque', "#"+id);
			}
		});

		$(document).on('change', 'input[name=globalDiscount]', function(){
			DocFormv2.updateTotal();
			$(this).val(NumberFormat.formatToDisplay($(this).val(), DocFormv2.getNumFormat(true)));
		});

		$('#formContent').on('change', 'select.shipping, select.packaging', function(){

			DocFormv2.getNumFormat(true);

			var id			= $(this).closest('div.row').attr('id');
			var rowId		= $(this).closest('div.row').find('.rowid').val();
			var $row		= $('#'+id);
			var $option		= $(this).find('option:selected');
			var unitAmount	= $option.attr('unitamount');

			// SHIPPING
			if ($(this).hasClass('shipping')){

				var advancedSettings = null;
				if($option.attr('advancedsettings') != ''){
					advancedSettings	= $.parseJSON($option.attr('advancedsettings'));
				}

				var shippingWeightUnit	= $('#shippingWeightUnit').val();
				var defaultWeightUnit	= $('#defaultWeightUnit').val();

				var shippingWeight		= NumberFormat.formatToFloat($('#shippingWeight').val(), DocFormv2.getNumFormat());
				shippingWeight			= new Big(shippingWeight);
				shippingWeight 			= Utils.convertWeightTo(shippingWeight, defaultWeightUnit, shippingWeightUnit);

				var totalAmount	= DocFormv2.isTaxesInc ? NumberFormat.formatToFloat($("#totalAmount .total").html(), DocFormv2.getNumFormat()) : NumberFormat.formatToFloat($("#totalTaxesFree .total").html(), DocFormv2.getNumFormat());

				var addresseCountryCode = $('#shipAddress_countrycode').val();
				var unitAmountFound		= false;
				var countryHasPrice		= false;
				var maxPrice			= 0;

				if (advancedSettings !== null && !$row.hasClass('shippingPriceFreeze')){

					if (advancedSettings.dynamicPrice == "Y"){
						switch (advancedSettings.billingMethod){
							case "price":
								var base = totalAmount;
								break;
							case "weight":
								var base = NumberFormat.formatToFloat(shippingWeight, DocFormv2.getNumFormat());
								break;
						}

						$.each(advancedSettings.rangeData, function(k,v){
							var currentMinRange = NumberFormat.formatToFloat(v.minRange, DocFormv2.pointformat);
							var currentMaxRange = NumberFormat.formatToFloat(v.maxRange, DocFormv2.pointformat);

							if (v.countries[addresseCountryCode]){
								countryHasPrice = true;
							}

							if (countryHasPrice){
								if (DocFormv2.isTaxesInc){
									if (v.countries[addresseCountryCode].unitAmountTaxesInc > maxPrice){
										maxPrice = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmountTaxesInc, DocFormv2.pointformat);;
									}
								} else {
									if (v.countries[addresseCountryCode].unitAmount > maxPrice){
										maxPrice = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmount, DocFormv2.pointformat);;
									}
								}
							}

							if (currentMaxRange === 0 && base >= currentMinRange){

								if (v.countries[addresseCountryCode]){
									if (DocFormv2.isTaxesInc){
										unitAmount = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmountTaxesInc, DocFormv2.pointformat);;
									} else {
										unitAmount = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmount, DocFormv2.pointformat);;
									}
									unitAmountFound = true;
								}
							} else if  (currentMaxRange != 0 && (base >= currentMinRange && base < currentMaxRange)) {
								if (v.countries[addresseCountryCode]){
									if (DocFormv2.isTaxesInc){
										unitAmount = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmountTaxesInc, DocFormv2.pointformat);;
									} else {
										unitAmount = NumberFormat.formatToFloat(v.countries[addresseCountryCode].unitAmount, DocFormv2.pointformat);;
									}
									unitAmountFound = true;
								}
							}

						});

						if (!countryHasPrice){

							unitAmount = 0;
							$(this).closest('tr').find('.shippingUnavaiblable').show();
							$(this).closest('tr').find('.shippingAvaiable').hide();

						} else {

							if (!unitAmountFound && advancedSettings.outOfRangeBehavior == "maxPrice"){
								unitAmount = maxPrice;
								$(this).closest('tr').find('.shippingUnavaiblable').hide();
								$(this).closest('tr').find('.shippingAvaiable').show();
							} else if (!unitAmountFound && advancedSettings.outOfRangeBehavior == "disable"){
								unitAmount = 0;
								$(this).closest('tr').find('.shippingUnavaiblable').show();
								$(this).closest('tr').find('.shippingAvaiable').hide();
							} else {
								$(this).closest('tr').find('.shippingUnavaiblable').hide();
								$(this).closest('tr').find('.shippingAvaiable').show();
							}

						}

					} else {
						$(this).closest('tr').find('.shippingUnavaiblable').hide();
						$(this).closest('tr').find('.shippingAvaiable').hide();
					}

					if (advancedSettings.trackingurl != ""){
						$('#shippingTrackingUrl').val(advancedSettings.trackingurl);
					}

				} else {
					$(this).closest('tr').find('.shippingUnavaiblable').hide();
					$(this).closest('tr').find('.shippingAvaiable').hide();
				}

			}

			if (!$row.hasClass('shippingPriceFreeze')){
				$row.find('.quantity').val(NumberFormat.formatToDisplay($option.attr('qt'), DocFormv2.getNumFormat(), undefined, 'qt'));
				$row.find('.unitAmountDisplay').val(NumberFormat.formatToDisplay(unitAmount, DocFormv2.getNumFormat(), undefined, 'unitAmount'));
			}


			var select = $row.find('[id^=row_accountingCode]');
			select.find('option[selected="true"]').attr('selected', "false");
			select.find('option[value="' + $option.attr('accountingcode') + '"]').attr('selected', "true");

			if($('#docAnalyticsCode').length) {
				$row.find('.analyticsCode').val($('#docAnalyticsCode').val());
			} else {
				$row.find('.analyticsCode').val($option.attr('analyticscode'));
			}

			if(DocFormv2.vat){

				var selectTax = $row.find('.tax').find('select');

				var wasHidden = false;
				if( selectTax.parent().is(':hidden')) {
					selectTax.parent().show();
					MyFacture.customForm();
					wasHidden = true;
				}

				if($('#rc_taxid').length > 0 && $('#rc_taxid').val() != 0){
					selectTax.val($('#rc_taxid').val());
				}else{
					selectTax.val($option.attr("taxid"));
				}

				if( wasHidden) {
					selectTax.parent().hide();
				}

			}

			DocFormv2.updateRow('#'+id);
		});

		$('input[type=checkbox][listname=paymediums][syscode=check]').on('click', function() {
			var forceDisplayCheckOrder = $('#forceDisplayCheckOrder');
			forceDisplayCheckOrder.prop('checked', $(this).prop('checked'));
		});
		$('input[type=checkbox][listname=paymediums][syscode=transfer]').on('click', function() {
			var forceDisplayBankAccount = $('#forceDisplayBankAccount');
			forceDisplayBankAccount.prop('checked', $(this).prop('checked'));
		});

		jQuery.data(document.body, 'prevAnalyticsCode', $("#docAnalyticsCode").val());


		$("#docAnalyticsCode").on('keyup', function(){
			var value	= $(this).val();
			var reg		= new RegExp('^'+value.substr(0, (value.length-1)), 'g');

			$('.row .analyticsCode').each(function(){

				if($(this).val() === jQuery.data(document.body, 'prevAnalyticsCode') || $(this).val() === ''){
					$(this).prop('value', value);
					$(this).val(value);
				}
			});

			jQuery.data(document.body, 'prevAnalyticsCode', value);
		});

		$('#displayedDate').on('change', function() {
			var el = $(this);
			var old = $('#raw_displayedDate');

			// change all mvt if they're equal to old doc displayedDate
			$('[id^=row_stockmove_]').each(function(i,e) {
				var mvt = $(e);
				if(mvt.val() === old.val()) {
					mvt.val(el.val());
				}
			});

			// record new displayedDate in old one
			old.val(el.val());
		});


		$('#docForm #shippingWeight').change(function(){
			var shippings = $('#docForm .docrow.shipping select.shipping');
			if (shippings.length > 0){
				$.each(shippings, function(i,v){
					var currentVal = $(v).val();
					var advancedSettings = $(v).find('option[value="'+currentVal+'"]').attr('advancedsettings');
					if (advancedSettings != undefined){
						$(v).trigger('change');
					}
				});
			}
		})

		$('#docForm #shippingWeightUnit').on( "selectmenuopen", function( event, ui ) {
			$(this)[0].oldValue = ui.value;
		});

		$('#docForm #shippingWeightUnit').on('selectmenuchange', function(event, ui){
			var oldUnit = $(this)[0].oldValue;
			var newUnit = ui.value;
			DocFormv2.updateWeightUnit(oldUnit, newUnit);
		});

		$('#linkParentTimetracking_all').change(function(){
			$('.link-timetracking').prop('checked', this.checked);
		});

		DocFormv2.initPayDeadlines();
		DocFormv2.computePayDeadlinesTotal();

		DocFormv2.updateTotal();
		DocFormv2.initRowOptions();
		DocFormv2.switchDoubleVat();
		MyFacture.stopWait();

		if($('#context').val() == 'copy'){
			DocFormv2.updateAllRows(true);
		}

		DocFormv2.changeValue($('#paydate'));

		MyTabs.initHorizontal('docFormPrefsContent');
		Qtip.init();

		setTimeout(function() {
			if(lockform) {
				$("input.updateRow").attr('readonly', 'true');
				$('#formContent select').attr('disabled', 'disabled');;
			}
		}, 1000);

		// init custom tags
		$('span.customTag[data-id=custom]', $('#subject, #formContent')).each(function(i, el) {
			var current	= $(el);
			var data	= JSON.parse(atob(current.attr('data-custom')));

			current.find('.modifier').val(data.modifier);
			current.find('.number').val(data.number);
			current.find('.interval').val(data.interval);
			current.find('.format').val(data.format);
		});

		$('.row').each(function() {
			DocFormv2.updateRowEInvoicingConformity($(this));
		});

		this.changeDocspeaker();

		DocFormv2.updateProductsCharacteristics();

        $('.formatOverrideTotal').keyup(_.debounce(function() {
            DocFormv2.formatOverrideTotalInput(this);
        }, 500));
		this.isLoaded = true;
	},

	isPurchase: function() {
		var currentLocation = window.location;
		return currentLocation.search.search(/\?_f=purchases_/g) > -1;
	},

	unFreezeShippigPrice: function(rowid){

		var shippings = $('#' + rowid + ' select.shipping');
		$('#'+rowid).removeClass('shippingPriceFreeze');
		$('#'+rowid).find('.shippingPriceFrozen').hide();
		if (shippings.length > 0){
			$.each(shippings, function(i,v){
				$(v).trigger('change');
			});
		}

	},

	/**
	 *
	 */
	checkForLockedRows: function() {

		$('#docForm .docrow.locked:not(.isLocked)').each(function(key, value) {
			var scope = $(value);

			scope.find('input[id^=row_name_]').attr('readonly', 'true');
			scope.find('input.updateRow').attr('readonly', 'true');
			scope.find('td.notes div.beforeRedactor').unbind('click');
			scope.find('td.notes div.displayRedactorOnClick').unbind('click');
			scope.find('.contextmenutoggler').remove();
			scope.addClass('isLocked');
		});

		$('#docForm .docrow.catalogLocked:not(.isCatalogLocked)').each(function(key, value) {
			var scope = $(value);
			scope.find('input[id^=row_name_]').attr('readonly', 'true');
			scope.addClass('isCatalogLocked');
		});

	},

    checkImpactStock: function(){
		var hasItemWithStock = false;

		if ((this.doctype == "delivery" || this.doctype == "invoice") && this.docDestockOn != this.doctype) {
			$("#stockImpact").prop('checked', false);
			return;
		}

		if ((this.doctype == "purDelivery" || this.doctype == "purInvoice") && this.docRestockOn != this.doctype) {
			$("#stockImpact").prop('checked', false);
			return;
		}

		if ((this.doctype == "creditnote") && this.restockOnCreditNote != 'Y') {
			$("#stockImpact").prop('checked', false);
			return;
		}

		if ((this.doctype == "purCreditNote") && this.docDestockOn == '') {
			$("#stockImpact").prop('checked', false);
			return;
		}

		$('#formContent .docrow').each(function(i, val) {
            var current = $(val);
            if (current.find('label[for^=row_whid_]').length > 0) {
                hasItemWithStock = true;
            }
        });
        $("#stockImpact").prop('checked', hasItemWithStock);
    },

	/**
	 *
	 * @param {type} oldUnit
	 * @param {type} newUnit
	 * @returns {undefined}
	 */
	updateWeightUnit : function(oldUnit, newUnit){

		var mutliplier = {
			'g_kg'  : 0.001,
			'kg_g'	: 1000,
			'oz_lb' : 0.001,
			'lb_oz' : 1000
		};

		var weight			= new Big(NumberFormat.formatToFloat($('#docForm #shippingWeight').val(), DocFormv2.getNumFormat()));
		var bigMultiPlier	= mutliplier[oldUnit+"_"+newUnit];

		var newWeight = weight.times(bigMultiPlier);
		$('#docForm #shippingWeight').val(NumberFormat.formatToDisplay(newWeight.toString(), DocFormv2.getNumFormat()));

	},

    /**
	 * Each time items document are updated, also updates
	 * - Number of products
	 * - Total weight and shipping costs if enabled and not manuals
	 * - Number of packages
     */
	updateProductsCharacteristics : function(){

		var docNumFormat = DocFormv2.getNumFormat();

		var nbItemsInRows 	= new Big(0);
		var totalWeight 	= new Big(0);
		var totalPacking 	= new Big(0);
		var zero		 	= new Big(0);
		var packingInfo		= new Array();

		// WEIGHT UNIT
		// - Shipping
		var shippingWeightUnit	= $('#docForm #shippingWeightUnit').val();
		// - Doc
        var docWeightUnit		= $('#weightUnit').val();
        if (docWeightUnit == '') {
            docWeightUnit = undefined;
        }
		// - Default for corp
		var defaultWeightUnit	= $('#defaultWeightUnit').val();

		$('#docForm .row.computable').each(function(key, element) {

            var qt = NumberFormat.formatToFloat($(element).find('.quantity').val(), docNumFormat);
            if (isNaN(qt)) {
                qt = 0;
                $(element).find('.quantity').val(qt);
            }
            qt = new Big(qt);

			nbItemsInRows = nbItemsInRows.plus(qt);

			var itemWeight = $(element).find('.itemWeight');
			var itemPacking = $(element).find('.itemPacking');

			// ITEM WEIGHT
			if(itemWeight.length > 0 && itemWeight.attr('value') !== ''){
				var weight = new Big(parseFloat(itemWeight.val()));
				if (weight > 0){
					if(itemWeight.attr('weightunit') !== ''){
						weight	= Utils.convertWeightTo(weight, docWeightUnit, defaultWeightUnit);
					}
					var tmpWeight 	= weight.times(qt);
					totalWeight 	= totalWeight.plus(tmpWeight);
				}
			}

			// ITEM PACKING group by item
			if(itemPacking.length > 0 && itemPacking.attr('value') !== ''){
				var packing = new Big(parseFloat(itemPacking.val()));
                var itemId = $(element).find("input[id^='row_linkedid_']").val();
                var declId = $(element).find("input[id^='row_declid_']").val();
				var packingTmp = {
					"itemId": itemId,
					"declId": declId,
					"qt": qt,
					"packing": packing
				};
				var sameItem = false;
                $.each(packingInfo, function(key, value){
                    if (value["itemId"] === itemId && value["declId"] === declId) {
                        value["qt"] = value["qt"].plus(qt);
                        sameItem = true;
					}
                });
				if (!sameItem) {
                    packingInfo.push(packingTmp);
				}

			}

		});

		// Total packing calculation
        $.each(packingInfo, function(key, value){
            if (!value["packing"].eq(zero)) {
                var tmpPacking 	= value["qt"].div(value["packing"]).round(0,3); // get the next natural number (0 - no decimal, 3 - ROUND_UP mode)
                totalPacking 	= totalPacking.plus(tmpPacking);
            }
        });

		$('#docForm .nbProducts').html(nbItemsInRows.toString());

		if (DocFormv2.isPurchase()) {
			return;
		}

		if (totalWeight != 0) {
			totalWeight = Utils.convertWeightTo(totalWeight, shippingWeightUnit, docWeightUnit);
		}
		var totalWeightFormatted = NumberFormat.formatToDisplay(totalWeight.toString(), docNumFormat);
		$('#docForm #shippingWeight').val(totalWeightFormatted);
		$('#docForm .itemsWeight').html(totalWeightFormatted);
		$('#docForm .shippingWeightUnit').html(shippingWeightUnit);

		var totalPackingFormatted = NumberFormat.formatToDisplay(totalPacking.toString(), docNumFormat);
		$('#docForm #shippingNbParcels').val(totalPackingFormatted);

		// GET SHIPPING CARRIER AND IF HE HAS ADVANCED SHIPPING SETTINGS
		// => TRIGGER CHANGE ON <select/> (change who browse shipping price according to total weight or total price)
		var shippings = $('#docForm .docrow.shipping select.shipping');
		if (shippings.length > 0){
			$.each(shippings, function(i,v){

				// Trigger change on delivery select if shipping is not frozen for update price according to advancedSettings
				if(!$(v).parents('.docrow').hasClass('shippingPriceFreeze')){
					var currentVal			= $(v).val();
					var advancedSettings	= $(v).find('option[value="'+currentVal+'"]').attr('advancedsettings');

					if (advancedSettings !== undefined && advancedSettings !== ''){
						$(v).trigger('change');
					}
				}

			});
		}
	},

	updatePurPriceFromBc: function(item, rowid){
		var purAmount = NumberFormat.formatToDisplay(item.purchaseAmount, this.getNumFormat());
		$('#docForm #row_'+rowid+' #row_purchaseAmount_'+rowid).val(purAmount).trigger('change');
	},

	changeWhidSerial: function(me,valo) {
		var newhd		= me.find('option:selected').val();
		var isSerial	= (valo === 'SERIAL');
		var rowMore		= me.closest('.rowMore');
		var inSTock		= rowMore.find('.autobc.serial').attr('e_autoBarcodeInStock');

		if(rowMore.find('.token-input-list').length && isSerial) {
			rowMore.find('.autobc.serial').attr('e_autobarcodewhid', newhd);
			rowMore.find('.autobc.serial').tokenInput('clear').tokenInput('more', {whid:newhd,inStock:inSTock,serialOrBarcode:((isSerial) ? 'serial' : 'barcode')});
		}
	},

	addRowFromBcValue: function(bcValue){

		var datas = {action:"recordCatalogueFromBc", bcValue:bcValue, itemsstartnum:Persistent.get("rowscounter"), thirdid: $("#thirdid").val()};
		datas = $.extend(datas, DocFormv2.getProperties(['rateCategory']));
		datas.ecoTaxId	= DocFormv2.ecoTax.id;
		datas.doctype	= DocFormv2.getProperties(['doctype']).doctype;
		datas.lang		= $("#docLang").val();
		datas = $.extend(true, datas, this.getNumFormat(true));

		MyFacture.post("catalogue", datas, function(data){

			if (data.length == 0){
				MyWindow.alert(Loc.g('Aucun produit pour ce code barre.'),{type:'warning'});
			} else {
				Catalogue.context = "doc";
				Catalogue.recordCatalogueCallback(data);
			}

		}, "json");

	},

	setGlobalDiscount : function(discountAmount, discountUnit){
		$('#globalDiscount').val(discountAmount).trigger('change');
		$('select[name="globalDiscountUnit"] option[value="' + discountUnit + '"]').prop('selected', true).trigger('change');
	},

	disableGlobalDiscount : function(disable){

		if(disable){
			$('#globalDiscount').prop('readonly', 'readonly');
			$('#globalDiscountUnit').addClass('disableClick');
		} else {
			$('#globalDiscount').prop('readonly', false);
			$('#globalDiscountUnit').removeClass('disableClick');
		}

	},

	setNote : function(value, reset){

		var redactor	= $('textarea[name="notes"]');
		var content		= redactor.redactor('get');

		if(reset == true){
			redactor.redactor('set', ' ');
		} else {

			if(content.length <= 2){
				redactor.redactor('set', value);
			} else {
				redactor.redactor('set', content + '<br>' + value);
			}
		}
	},

	setShippingRowsAsFreeForPromotion : function(){

		if($('.shippingsitemslist').length > 0)	{
			$('.shippingsitemslist').each(function( index ) {
				$(this).closest('tr').find('.unitAmountDisplay').val('0').prop('readonly', true).trigger('change');
				$(this).closest('tr').find('.promotionFreeShippingRow').removeClass('hidden');
			});
		}

	},

	renableShippingRows : function(){

		if($('.shippingsitemslist').length > 0)	{
			$('.shippingsitemslist').each(function( index ) {
				$(this).closest('tr').find('.unitAmountDisplay').prop('readonly', false);
				$(this).closest('tr').find('.promotionFreeShippingRow').addClass('hidden');
			});
		}

	},

	addRowFromItemId: function(itemId, declid, thirdid){

		var declid		= declid === undefined ? 0 : declid;
		var useEcotaxe	= $("#useEcotaxe").val();
		var lang		= $("#docLang").val();

		var weightUnits	= {
			default : $('#defaultWeightUnit').val(),
			current : $('#weightUnit').val()
		};

		var datas = {
			action:			"recordCatalogue",
			declid: 		declid,
			itemid:			itemId,
			currentTab:		'items',
			doubleVat: 		DocFormv2.doubleVat,
			itemsstartnum:	Persistent.get("rowscounter"),
			thirdid: 		thirdid,
			useEcotaxe:		useEcotaxe,
			doclang:		lang,
			weightUnits: 	weightUnits
		};

		datas 			= $.extend(datas, DocFormv2.getProperties(['rateCategory']));
		datas.ecoTaxId 	= DocFormv2.ecoTax.id;
		datas.doctype 	= DocFormv2.getProperties(['doctype']).doctype;
		datas 			= $.extend(true, datas, this.getNumFormat(true));

		MyFacture.post("catalogue", datas, function(data){
			Catalogue.context = "doc";
			Catalogue.recordCatalogueCallback(data);
		}, "json");

	},

	ask5minSave : function(action){
		if($('div.ui-dialog').length > 0) {
			setTimeout(function(){
				DocFormv2.ask5minSave();
			}, 900000);
		} else {
			var options = {
				title	: Loc.g('Sauvegarder votre travail'),
				buttons	: [
                    {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                    {text : Loc.g("Enregistrer et continuer l'édition"), click : function(){$(this).dialog("close");DocFormv2.record('edit');}}
				],
				height:210
			};
			var params = {action : "ask5minSave", doctype : this.doctype};
			MyWindow.load(action, params, options);
		}
	},

	getDefaultUnit		: function(){return $("#defaultUnit").val();},
	getDefaultTax		: function(){return $("#defaultTax").val();},
	getDefaultTax2		: function(){return $("#defaultTax2").val();},
	getDefaultPackaging	: function(){return $("#defaultPackaging").val();},
	getDefaultShipping	: function(){return $("#defaultShipping").val();},

	/***		ADDRESSES		***/
	editAddress: function(source, fromPurchase, rowSelection, doctype){

        if (doctype == undefined) {
            doctype = $('#doctype').val();
        }

		if(fromPurchase == undefined || fromPurchase == "doc" ) {
			var action	= "doc";
		}else {
			var action = "purchases_purchases";
		}

		var title =  "";
		switch(source){
			case 'third' :
				title = Loc.g("Adresse de facturation");
				break;
			case 'ship' :
				title = Loc.g("Adresse de livraison");
				break;
			default :
				title = Loc.g('Adresse société');
		}

		var options = {
			title	: title,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#docAddressForm").submit();
					}
				}
			],
			callback	: function(){DocFormv2.prepareAddressForm(source, action, doctype);}
		};

		var prefix = DocFormv2.getAddressPrefix(source);

		var fileOpts = {action : "addressForm", doctype : this.doctype, src : source};

		if(rowSelection !== undefined){
			$.extend(fileOpts, {
				'doctype' : doctype,
				'docids' : rowSelection,
			})
		}

		fileOpts.selected		= $("#"+prefix+"originalid").val();
		fileOpts.countrycode	= $("#"+prefix+"countrycode").val();

		if("third" == source || "ship" == source){
			fileOpts.thirdid = $("#thirdid").val();
		}
		else if("thirdShip" == source){
			var thirdid = $('#shipthirdid').val();
			var idthird = thirdid.split("_");
			fileOpts.thirdid = idthird[1];
		}
		MyWindow.load(action, fileOpts, options);

	},

	getAddressPrefix: function(target){
		var prefix = "";

		switch(target){
			case 'third' :
				prefix = "thirdAddress_";
				break;
			case 'ship' :
				prefix = "shipAddress_";
				break;
			case 'thirdShip' :
				prefix = "thirdShipAddress_";
				break;
			case 'popup' :
				prefix = "address_";
				break;
			default :
				prefix = "corpAddress_";
		}
		return prefix;
	},

	prepareAddressForm: function(source, action, doctype){
		var formId = "docAddressForm";
		var options = {
			data : {},
			success : function(data){
				DocFormv2.recordAddressCallback(data);
			}, dataType : "json"};

		if($('#docids').length > 0)
			options['data']['docids'] = $('#docids').val();

        if (doctype == undefined) {
            doctype = ($('#docids').length > 0 ? $('#doctype').val() : this.doctype);
        }

		MyForm.prepare(formId, action+"&doctype="+ doctype +"&action=recordAddress", options, true);
		MyFacture.initEvent();
	},

	recordAddressCallback: function(data){
		var formIsOk = MyForm.processJson(data, "addressForm");
		if(formIsOk){
			if(data.target){
				var addressDetails = {};
				var fieldToLoad = new Array("name", "part1", "part2", "part3", "part4", "zip", "town", "countrycode","state");
				var field = null;

				for(var f=0; f < fieldToLoad.length; f++){
					field = fieldToLoad[f];
					addressDetails[field] = Utils.exists("address_"+field) ? $("#address_"+field).val() : "";
				}

				if(data.addrid){
					addressDetails.originalid = data.addrid;
				}

				if(data.toHTML){
					addressDetails.toHTML = data.toHTML;
				}

				if(data.docUpdated !== undefined){

					var opt = {
						title:	data.docUpdated ? Loc.g('Documents mis à jour') : Loc.g('Erreur lors de la mise à jour'),
						type:	data.docUpdated ? 'confirm' : 'error',
						buttons: [{
							text: Loc.g("Ok"),
							click: function () {
								$(this).dialog("close");
								Listing.groupedActiontoggler($('#groupedAction'), true);
							}
						}],
					};

					MyWindow.alert(data.docUpdated ? Loc.g("Les documents sélectionnés ont été mis à jour") : Loc.g("Les documents n'ont pas pu être mis à jour"), opt);

				} else {
					DocFormv2.setAddress(data.target, addressDetails);
				}

			}
			MyWindow.close();
		}
	},

	setAddress: function(target, details, convertInRawTags){

		convertInRawTags = undefined == convertInRawTags ? true : convertInRawTags;

		var prefix = DocFormv2.getAddressPrefix(target);

		if(target != "popup"){

			$("#"+prefix+"countrycode").val(details.countrycode	? details.countrycode	: "");
			$("#"+prefix+"id").val(details.id					? details.id			: "0");
			$("#"+prefix+"originalid").val(details.originalid	? details.originalid	: "0");
			$("#"+prefix+"toHTML")[0].innerHTML = details.toHTML ? Text.getBr(details.toHTML) : "";

		} else {

			if (details.countrycode != ""){
				$("#"+prefix+"countrycode").val(details.countrycode	? details.countrycode	: "ignore");
			}
			$("#"+prefix+"toHTML").val(details.toHTML ? Text.getBr(details.toHTML) : "");

		}

		var detailFieldName = ['name', 'part1', 'part2', 'part3', 'part4', 'zip', 'town', 'state'];

		$.each(detailFieldName, function(i, fieldName){
			var $this = $('#'+prefix+fieldName);
			if($this.length > 0){
				$this.val(details[fieldName] ? details[fieldName] : "");
				Persistent.set($this.attr('id'), details[fieldName], $this.parent());

				if(convertInRawTags){
					$this.val(Text.getRawTags($this.val()));
				}
			}
		});


		var shippings = $('#docForm .docrow.shipping select.shipping');
		if (shippings.length > 0){
			$.each(shippings, function(i,v){
				var currentVal = $(v).val();
				var advancedSettings = $(v).find('option[value="'+currentVal+'"]').attr('advancedsettings');
				if (advancedSettings != undefined){
					$(v).trigger('change');
				}
			});
		}

	},

	changeAddress: function(){

		var prefix = "address_";
		var addrid = $("#"+prefix+"addressesChoice").val();
		var addrDetails = Persistent.get(prefix + addrid, true, true);

		DocFormv2.setAddress("popup", addrDetails, false);
		TokenInput.updateAddress(prefix);

	},

	/***		THIRD		***/
	changeThird : function(fromPurchase){

		if(fromPurchase == undefined) {
			var action	= "doc";
			var title	= Loc.g("Modifier le client");
		}else {
			var action = "purchases_purchases";
			var title	= Loc.g("Modifier le fournisseur");
		}

		var options = {
			title	: title,
			width	: DocTools.preFormWidth,
			buttons	: [
				{text : Loc.g('Annuler'), click : function(){$(this).dialog("close");}},
				{text : Loc.g('Enregistrer'), click : function(){$("#docChangeThirdForm").submit();}}
			],
			callback	: function(){DocFormv2.prepareChangeThirdForm(action);}
		};

		var fileOpt = {
			action	: "changeThirdForm",
			doctype : this.doctype,
			docid	: this.docid
		};
		MyWindow.load(action, fileOpt, options);
	},

	prepareChangeThirdForm: function(action){

		var formId = "docChangeThirdForm";

		var options = {
			success:function(data){
				DocFormv2.recordChangeThirdCallback(data, action);
			},
			dataType:"json"
		};

		var params = {action:'recordChangeThird', doctype: this.doctype, docid: this.docid};
		MyForm.prepare(formId, action+"&"+$.param(params), options, true);
		MyFacture.initEvent("#docChangeThirdForm");
		DocTools.switchCreateForThird();

	},

	recordChangeThirdCallback: function(data, action){
		var formIsOk = MyForm.processJson(data, "docChangeThirdForm");
		if(formIsOk && data.thirdinfos){

			//reinject datas to save the doc
			for(var pos in data.thirdinfos){
				$('input[name='+pos+']').val(data.thirdinfos[pos]);
			}

			var isPerson    = data.thirdinfos['thirdIsPerson'] == 'Y';
			var peopleName  = '-';
			var contactName = '';
			var contactId   = 0;
			if (isPerson) {
				peopleName  = data.thirdinfos['contactName'];
				contactName = data.thirdinfos['contactName'];
				contactId   = data.thirdinfos['contactId'];
			}

			$('#thirdInfoDiv #thirdident').val(data.thirdinfos.thirdIdent);
			$('#thirdNameDiv #thirdVatNumDiv').val(data.thirdinfos.thirdVat);
			$('#thirdAddress_toHTML').html(data.thirdinfos.thirdAddress);
			$('#shipAddress_toHTML').html(data.thirdinfos.shipAddress);

			$('#contactNameDiv span.namePeople-text').html(peopleName);
			$('#contactNameDiv #contactName').val(contactName);
			$('#contactNameDiv #contactId').val(contactId);

			$('.editContact').attr('onClick', "DocFormv2.changeContact("+(action != "doc" ? "'Y'" : "")+");");

			$('.hideForPerson').toggleClass('hidden', isPerson);
			$('.thirdInfoPreview').removeClass('hidden');

			MyWindow.close();
		}
	},

	/***		THIRD CONTACT		***/
	changeContact : function(fromPurchase){
		var thirdid	= $('#thirdid').val();

		var action	= 'doc';

		var options = {
			title	: Loc.g("Modifier le contact"),
			width	: 1000,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#docChangeContactForm").submit();
					}
				}
			],
			callback : function(){
				DocFormv2.prepareChangeContactForm(action);
			}
		};

		var fileOpt = {
			action				: "changeContactForm",
			doctype				: this.doctype,
			docid				: this.docid,
			thirdid				: thirdid,
			fromPurchasesDoc	: (fromPurchase != undefined ? fromPurchase : 'N')
		};

		MyWindow.load(action, fileOpt, options);

	},

	prepareChangeContactForm : function(action){

		var formId = "docChangeContactForm";

		var options = {
			success		: function(data){
				DocFormv2.recordChangeContactCallback(data);
			},
			dataType	: "json"
		};

		var params = {
			action	: 'recordChangeContact',
			doctype	: this.doctype,
			docid	: this.docid
		};

		MyForm.prepare(formId, action+"&"+$.param(params), options, true);

		MyFacture.initEvent("#docChangeContactForm");
		DocFormv2.switchCreateForContact();

	},

	recordChangeContactCallback: function(data){

		var formIsOk = MyForm.processJson(data, "docChangeThirdForm");

		if(formIsOk && data.contactinfos){
			//reinject datas to save the doc
			$('#contactNameDiv span.namePeople-attentionto').show();
			$('#contactNameDiv span.namePeople-text').html(data.contactinfos.name);
			$('#contactNameDiv #contactName').val(data.contactinfos.name);
			$('#contactNameDiv #contactId').val(data.contactinfos.id);
			$('ul li.btnDeleteContact').show();
			MyWindow.close();
		}

	},

	deleteContact: function(){
		$('#contactNameDiv span.namePeople-text').html('-');
		$('#contactNameDiv #contactName').val('');
		$('#contactNameDiv #contactId').val(0);
	},

	changeDocspeaker: function(){
		var speaker = $('#docspeakerStaffId option:selected');

		var tel = speaker.attr('tel');
		var fax = speaker.attr('fax');
		var mobile = speaker.attr('mobile');
		var email = speaker.attr('email');
		var status = speaker.attr('status');

		if(status === "ok"){
			if (tel != ""){
				$('#docspeakerTel i').html(tel);
				$('#docspeakerTel').fadeIn();
			} else {
				$('#docspeakerTel').fadeOut();
			}

			if (fax != ""){
				$('#docspeakerFax i').html(fax);
				$('#docspeakerFax').fadeIn();
			} else {
				$('#docspeakerFax').fadeOut();
			}

			if (mobile != ""){
				$('#docspeakerMobile i').html(mobile);
				$('#docspeakerMobile').fadeIn();
			} else {
				$('#docspeakerMobile').fadeOut();
			}

			if (email != ""){
				$('#docspeakerEmail i').html(email);
				$('#docspeakerEmail').fadeIn();
			} else {
				$('#docspeakerEmail').fadeOut();
			}
		}else{
			$('#docspeakerTel').fadeOut();
			$('#docspeakerFax').fadeOut();
			$('#docspeakerMobile').fadeOut();
			$('#docspeakerEmail').fadeOut();
		}

	},

	switchCreateForContact : function(){
		var checked = $('#doccontact_choice input:checked').val();
		if("new"==checked)
			$("#docnewcontactform").slideDown(200, function(){
	            MyFacture.customForm("#docnewcontactform");
			});
		else
			$("#docnewcontactform").slideUp(200);
	},
	/***		DOCFORM PREFS		***/

	//COLUMN DISPLAY
	updateDisplayColumn: function(column){

		var check				= column.is(':checked') ? 'Y' : 'N';
		var colname				= column.attr('col');
		var global				= $('.'+colname);
		var doubleVat			= $('.tax2');


		if(	(column.attr('invert') && check == 'Y') ||
			(!column.attr('invert') && check == 'N')) {
			global.removeClass('hidden');

			switch(DocFormv2.columnsDisplay[colname]) {
				case 'hidden':
					global.show();
					break;
				default:

					// on items
					global.removeClass(DocFormv2.columnsDisplay[colname]);

					if(colname === 'discount') {
						if($('#discountByRows').prop('checked')) {
							global.show();
							global.removeClass(DocFormv2.columnsDisplay[colname]);
						} else {
							global.hide();
						}
					} else {
						global.show();
						global.removeClass(DocFormv2.columnsDisplay[colname]);
					}

					// on column
					$('th.'+colname).find('span.eye-container').html('<i class="fa fa-eye"></i>');
					break;
			}
			if (colname === "tax" && DocFormv2.doubleVat) {
				doubleVat.show();
				doubleVat.removeClass('hidden');
				doubleVat.removeClass(DocFormv2.columnsDisplay['tax2']);
			}
		} else {
			global.removeClass('hidden');
			switch(DocFormv2.columnsDisplay[colname]) {
				case 'hidden':
					global.hide();
					break;
				default:

					// on items
					if(colname === 'discount') {
						if($('#discountByRows').prop('checked')) {
							global.show();
							global.addClass(DocFormv2.columnsDisplay[colname]);
						} else {
							global.hide();
						}
					} else {
						global.addClass(DocFormv2.columnsDisplay[colname]);
					}

					// on column
					$('th.'+colname).find('span.eye-container').html('<i class="fa fa-eye-slash eye-disabled"></i>');
					break;
			}
			if (colname === "tax" && DocFormv2.doubleVat) {
				doubleVat.show();
				doubleVat.removeClass('hidden');
				doubleVat.addClass(DocFormv2.columnsDisplay['tax2']);
			}
		}
	},

	changeValue: function(element){
		switch(element.attr("listname")){
			case 'paydates' :
				DocFormv2.changePayDate();
				break;

		}
	},

	clickValue: function(element){
		switch(element.attr("listname")){
			case 'paymediums' :
				DocFormv2.clickPayMedium(element);
				break;
		}
	},

	changePayDate: function(){

		var syscode = $("#paydate option:selected").attr("syscode");
		var context = $("#docForm #context").val();
		var field = "";
		switch(syscode){
			case 'custom' :
				field = "paydate_custom_tr";
				var nbdays = $("#paydate option:selected").attr("nbdays");
                var date = moment().add(nbdays, 'days');
				var endmonth = $("#paydate option:selected").attr("endmonth");
				if(endmonth === 'Y'){

					var date = moment().add(nbdays, 'days');
					date = moment(date).endOf('month');
				} else {
					var date = moment().add(nbdays, 'days');
				}
                var format = 'DD/MM/YYYY';
                if ($('[datepicker]').attr('format') == 'mdy') {
                    format = 'MM/DD/YYYY';
                }
                date = date.format(format);
				if(this.isLoaded){
					$('#paydate_custom').val(date);
				}
				if($('#deposit_paydate_custom').val() == ""){
					$('#deposit_paydate_custom').val(date);
				}
				break;

			case '30days':
			case '45days':
			case '60days':
			case '90days':
				field = "paydate_endmonth_tr";
				break;
			case 'xdays':
				field = "paydate_xdays_tr";
				break;
			case 'scaled':
				field = "paydate_scaled_tr";
				break;
			case 'deadlines':
				field = "paydate_deadlines";
				break;
		}

		if(field != ''){

			$("#"+field+":hidden").fadeIn(100, function(){
				MyFacture.customForm("#"+$(this).attr('id'));
			});


			$(".paydateMore:not(#"+field+"):visible").fadeOut(100);

			if(syscode == 'scaled'){
				$("#paydate_xdays_tr").fadeIn(100, function(){MyFacture.customForm($(this));});
			}

			if(syscode == 'deadlines' && $('#deadline_list li').length == 0){
				DocFormv2.addPayDeadline();
				DocFormv2.initPayDeadlines();
			}

		} else {

			$(".paydateMore:visible").fadeOut(100);

		}
	},

	initPayDeadlines : function(){

		$('#deadline_list').delegate('input.amount', 'keyup', function(){
			DocFormv2.computePayDeadlinesTotal();
		});
	},

	computePayDeadlinesTotal : function(){

		var totalAmount = Big(0);

		$('#deadline_list input.amount').each(function(){
			var formattedValue = NumberFormat.formatToFloat($(this).val(), DocFormv2.numformat);

			totalAmount = totalAmount.plus(formattedValue);
		});

		if(totalAmount.toString() > DocFormv2.totalDue){
			$('#deadlinesTotal table').addClass("error");
		}else{
			$('#deadlinesTotal table').removeClass("error");
		}

		$('td.totalDeadlines').html(NumberFormat.formatToDisplay(totalAmount.toString(), DocFormv2.numformat));

		return totalAmount;

	},

	addPayDeadline : function(){
		var deadline = $('.deadline_tpl').html();
		deadline = $(deadline);

		var date	= new Date();
		var key		= ''+Math.ceil((Math.random() * 100)*(Math.random() * 10))+date.getTime()+Math.ceil(Math.random() * 1000);

		deadline.addClass('deadline');
		deadline.find('.deadlineid').attr('name', 'paydate_deadlines['+key+'][id]').attr('id', 'paydate_deadlines_'+key+'_id');
		deadline.find('.date').attr('name', 'paydate_deadlines['+key+'][date]').attr('id', 'paydate_deadlines_'+key+'_date');
		deadline.find('.amount').attr('name', 'paydate_deadlines['+key+'][amount]').attr('id', 'paydate_deadlines_'+key+'_amount');
		deadline.attr('id', 'deadline_'+key);

		deadline.appendTo('#deadline_list');

		MyFacture.customForm('#deadline_'+key);

		if($('#deadline_list li').length == 1){
			$('#deadline_list li:eq(0)').find('a').hide();
		}else{
			$('#deadline_list li:eq(0)').find('a').show();
		}

		// Add datepicker :
		var $input = $('input.date', deadline);
		var lang		= window.App.lang;
		var format		= $input.attr('format');
		var dateFormat	= "dd/mm/yy";
		switch (format) {
			case 'mdy':
				dateFormat = "mm/dd/yy";
				break;
		}
		$.datepicker.setDefaults($.datepicker.regional[lang]);
		var datePickerOption = {
			dateFormat			: dateFormat,
			showOtherMonths		: true,
			selectOtherMonths	: true,
			changeMonth			: true,
			changeYear			: true
		};
		$input.datepicker(datePickerOption);

		return '#deadline_'+key;
	},

	removePayDeadline : function(elt){
		$(elt).closest('.deadline').remove();
		DocFormv2.computePayDeadlinesTotal();

		if($('#deadline_list li').length == 1){
			$('#deadline_list li:eq(0)').find('a').hide();
		}else{
			$('#deadline_list li:eq(0)').find('a').show();
		}
	},

	shortcutPayDeadline : function(nbDeadlines){

		var deadline	= Math.round(parseFloat(DocFormv2.totalDue, 10) / parseInt(nbDeadlines, 10) * 100) / 100;
		var error		= DocFormv2.totalDue - (deadline * nbDeadlines);

		if($('#deadline_list .date:first').val() != ''){

			var firstDate = $('#deadline_list .date:first').val();

			if($('#deadline_list .date:first').attr('format') == 'dmy'){
				var dueDate = moment(firstDate, "DD-MM-YYYY");
			}else{
				var dueDate = moment(firstDate, "MM-DD-YYYY");
			}
		}else{
			var dueDate = moment();
		}

		$('#deadline_list').empty();

		for(var i = 0; i < nbDeadlines; i++){
			var key = DocFormv2.addPayDeadline();

			if(i == 0){
				var amount = deadline + error;
			}else{
				var amount = deadline;
			}

			var displayDate = moment(dueDate.format('MM/DD/YYYY'));
			displayDate.add(i, 'months');


			if($(key).find('.date').attr('format') == 'dmy'){
				$(key).find('.date').val(displayDate.format('DD/MM/YYYY'));
			}else{
				$(key).find('.date').val(displayDate.format('MM/DD/YYYY'));
			}
			$(key).find('.amount').val(NumberFormat.formatToDisplay(amount, DocFormv2.numformat)).trigger('keyup');


		}
	},

	updateAmountDeadline : function(){

		var nbDeadlines 	= 0;
		$('#docForm #deadline_list .deadline').each(function(){
			nbDeadlines++;
		});

		var deadline	= Math.round(Big(parseFloat(DocFormv2.totalDue, 10)).div(Big(parseInt(nbDeadlines, 10))) * 100) / 100;
		var error		= Big(DocFormv2.totalDue).minus(Big(deadline).times(nbDeadlines));

		$('#docForm #deadline_list .deadline').each(function(){
			var amount = 0;
			if($(this).is(':first-child')){
				$('.amount', this).val(NumberFormat.formatToDisplay(Big(deadline).plus(error).toString(), DocFormv2.numformat)).trigger('keyup');
			} else{
				$('.amount', this).val(NumberFormat.formatToDisplay(Big(deadline).toString(), DocFormv2.numformat)).trigger('keyup');
			}
		});

	},

	clickPayMedium: function(element){
		var isChecked	= element.prop("checked");
		var syscode		= element.attr("syscode");
		var field		= "";

		switch(syscode){
			case 'check' :
				field = "checkOrdersList";
				break;
			case 'transfer' :
				field = "bankAccountsList";
				break;
			case 'pick' :
				field = "picksList";
				break;
			case 'other' :
				field = "other";
				break;
		}
	},

	/***		VALUESLISTS AND ITEMSLISTS EDITING		***/
	editValuesList: function(listName){
		RankedList.editValuesList(listName, DocFormv2.getNumFormat(true), '', '', 'DocFormv2.recordValuesListCallback');
	},

	openUnitsDialog: async function(){
		const store = window.sellsyapp.config.globalProperties.$store;

		store.state.popupPanel.unitsModal.display = true;

		// Remove existing handler if any
		if (this.unitsUpdatedHandler) {
			EventBus.off('unitsUpdated', this.unitsUpdatedHandler);
		}

		// Store handler reference for cleanup
		this.unitsUpdatedHandler = () => {
			// Clean up after execution
			EventBus.off('unitsUpdated', this.unitsUpdatedHandler);
			this.unitsUpdatedHandler = null;
			window.location.reload();
		};

		EventBus.on('unitsUpdated', this.unitsUpdatedHandler);
	},

	openVatRateDialog: async function(){
		const store = window.sellsyapp.config.globalProperties.$store;

		// Check if modules are already registered to avoid duplicate registration
		if (!store.hasModule('vatStore')) {
			const { default: vatStore } = await import('stores/taxes/vatStore');
			store.registerModule('vatStore', vatStore);
		}

		if (!store.hasModule('languagesStore')) {
			const { default: languagesStore } = await import('stores/languages/languagesStore');
			store.registerModule('languagesStore', languagesStore);
		}

		// Fetch data and display dialog
		await Promise.all([
			store.dispatch('vatStore/fetchTaxes'),
			store.dispatch('languagesStore/fetchLanguages')
		]);

		store.state.popupPanel.vatRateDialog.display = true;

		// Remove existing handler if any
		if (this.vatRatesUpdatedHandler) {
			EventBus.off('vatRatesUpdated', this.vatRatesUpdatedHandler);
		}

		// Store handler reference for cleanup
		this.vatRatesUpdatedHandler = () => {
			// Clean up after execution
			EventBus.off('vatRatesUpdated', this.vatRatesUpdatedHandler);
			this.vatRatesUpdatedHandler = null;
			window.location.reload();
		};

		EventBus.on('vatRatesUpdated', this.vatRatesUpdatedHandler);
	},

	recordValuesListCallback: function(data){
		var formIsOk = MyForm.processJson(data, "valuesListForm");
		if(formIsOk){
			var valuesListSelector	= data.listname		? data.listname+"valueslist"	: "";
			var valuesListContent	= data.listcontent	? data.listcontent				: "";

			if(0<valuesListSelector.length && 0<valuesListContent.length){
				var id = "";
				var oldSelected = "";

				switch(data.listname){
					case 'paydates' :
						id = "paydate";
						oldSelected = $("#"+id).val();
						$("#paydateDiv").html(Text.replace(valuesListContent, "%idToSet%", id));
						$("#"+id).val(oldSelected);
						break;
					case 'paymediums' :
						var checked = new Array();
						$(".paymediums").each(function(){
							if($(this).prop('checked'))
								checked.push($(this).attr("id"));
						});
						$("#paymediumDiv").html(Text.replace(valuesListContent, "%idToSet%", "paymedium"));
						for(var c=0; c<checked.length; c++){
							$("#"+checked[c]).prop("checked", true);
						}
						MyFacture.customForm("#paymediumDiv");
						break;

					case 'paycheckorders':
						id = "paycheckorder";
						oldSelected = $("#"+id).val();
						$("#paymedium_checkOrdersListDiv").html(Text.replace(valuesListContent, "%idToSet%", id));
						$("#"+id).val(oldSelected);
						break;

					case 'docspeakers' :
						id = "docspeaker";
						oldSelected = $("#"+id).val();
						$("#docSpeakersListDiv").html(Text.replace(valuesListContent, "%idToSet%", id));
						$("#"+id).val(oldSelected);
						break;

					default :
						if(data.listname == "taxes" && data.taxestotals){
							var numformat	= DocFormv2.getNumFormat(true);
							var taxestotals = Text.replace(data.taxestotals, "%currency%", numformat.currency);
							$("#taxesTotals").html(taxestotals);
							$("#taxesTotals").find(".currency"+numformat.currencypos).html(numformat.currency);
						}

						var newVal = "";
						var rowId	= "";

						$("."+valuesListSelector).each(function(){

							var id = $(this).attr("idToSet");

							$(this).removeClass("form_warn_change");

							oldSelected = $("#"+id) ? $("#"+id).val() : "";
							newVal	= Text.replace(valuesListContent, '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>', "");
							newVal	= Text.replace(newVal, '<!--?xml version="1.0" encoding="UTF-8" standalone="yes"?-->', "");
							newVal	= Text.replace(newVal, "%idToSet%", id);
							$(this).html(newVal);

							if($("#"+id)){
								rowId = "row_"+$(this).attr("pos");

								if($("#"+id).find('option[value='+oldSelected+']').length > 0){
									$("#"+id).val(oldSelected);
								}else{
									$("#"+id).val($("#"+id).find('option:first').val());
								}
								MyFacture.customForm("#"+rowId);
							}
						});


						var defaultField = "";
						if(data.listname === 'units'){
							defaultField = "defaultUnit";
						}

						if(data.listname === "taxes"){
							defaultField = "defaultTax";
						}

						if(defaultField  !== ""){
							oldSelected = $("#"+defaultField) ? $("#"+defaultField).val() : "";
							newVal = Text.replace(valuesListContent, "%idToSet%", defaultField);
							$("#"+defaultField+"Div").html(newVal);
							$("#"+defaultField).val(oldSelected);
						}

						if(data.listname === 'taxes'){
							defaultField = "defaultTax2";
							oldSelected = $("#"+defaultField) ? $("#"+defaultField).val() : "";
							newVal = Text.replace(valuesListContent, "%idToSet%", defaultField);
							$("#"+defaultField+"Div").html(newVal);
							$("#"+defaultField).val(oldSelected);
						}

						DocFormv2.updateTotal();
						break;

				}
			}
			MyWindow.close();
		}
	},

	editItemsList: function(listName){
		RankedList.editItemsList(listName, DocFormv2.getNumFormat(true), '', 'DocFormv2.recordItemsListCallback');
	},

	recordItemsListCallback: function(data){
		var formIsOk = MyForm.processJson(data, "itemsListForm");
		if(formIsOk){

			var itemsListSelector	= data.listname		? data.listname+"itemslist"	: "";
			var itemsListContent	= data.listcontent	? data.listcontent			: "";

			if(0<itemsListSelector.length && 0<itemsListContent.length){

				var id			= "";
				var divId		= "";
				var selectId	= "";

				switch(data.listname){
					case "packagings":
						id			= "prefDoc_defaultPackaging";
						divId		= "defaultPackagingDiv";
						selectId	= "defaultPackaging";
						break;
					case "shippings":
						id			= "prefDoc_defaultShipping";
						divId		= "defaultShippingDiv";
						selectId	= "defaultShipping";
						break;
				}

				itemsListContent = Text.replace(itemsListContent, "%idToSet%", selectId);

				var oldSelected = $("#"+selectId).val();
				$("#"+divId).html(itemsListContent);
				$("#"+selectId).val(oldSelected);
				MyFacture.customForm("#"+divId);

			}
			MyWindow.close();
		}
	},

	/***		NUMBER FORMAT		***/
	changeNumFormatSeparators : function(){

		var oldnf = $.extend(oldnf, this.numformat);

		var decimals	= $('select[name=num_separators] option:selected').attr('decimals');
		var thousands	= $('select[name=num_separators] option:selected').attr('thousands');

		$('input[name=num_decimals]').val(''+decimals);
		$('input[name=num_thousands]').val(''+thousands);

		var newnf = DocFormv2.getNumFormat(true);

		DocFormv2.updateNumFormat(oldnf, newnf);
	},

	changeNumFormatPrecision : function(){

		var oldnf = $.extend(oldnf, this.numformat);
		var newnf = DocFormv2.getNumFormat(true);
		DocFormv2.updateNumFormat(oldnf, newnf);

	},

	changeNumFormatCurrency: function(target){

		target			=  target==undefined ? 'body' : target;
		var numformat	= DocFormv2.getNumFormat(true);

		var left		= NumberFormat.currencyToLeft(numformat) ? numformat.currency : "";
		var right		= NumberFormat.currencyToRight(numformat) ? numformat.currency : "";

		$("span.currency, option.currency", target).each(function(){
			$(this).html(numformat.currency);
		});

		$(".currencyleft", target).each(function(){
			$(this).html(left);
		});
		$(".currencyright", target).each(function(){
			$(this).html(right);
		});
	},

	refreshNumFormat : function(){

		var currentSelected		= $('select[name=currency]').val();
		var currentSelectedHtml = $('select[name=currency] option[value="'+currentSelected+'"]').html();

		DocFormv2.numformat.name			= "";
		DocFormv2.numformat.currency		= currentSelectedHtml;
		DocFormv2.numformat.decimals		= $("#num_decimals").val();
		DocFormv2.numformat.thousands		= $("#num_thousands").val();
		DocFormv2.numformat.currencypos		= $("#num_currencypos").val();
		DocFormv2.numformat.precision		= parseInt($("#num_precision").val(), 10);

		DocFormv2.numformat.precisioncustom = {};
		var customPrecision = $("select[name^=num_precisioncustom]");
		$.each(customPrecision, function(k,v){
			var col = $(v).attr('id').split('_')[2];
			var val = $(v).val();
			DocFormv2.numformat.precisioncustom[col] = val;
		});

	},

	getSimpleNumFormat : function() {
		return {'name': "", 'currency': "", 'decimals': ".", 'thousands': "", 'currencypos': "", 'precision': ""};
	},

	getNumFormat : function(reload){
		if(reload === true){
			DocFormv2.refreshNumFormat();
		}
		return DocFormv2.numformat;

	},

	updateNumFormat : function(inputNumFormat, outputNumFormat){

		$("input.updateRow").each(function(){
			var precisionCustomCurrent = $(this).attr('e_formatnum_precisioncustom');
			$(this).val(NumberFormat.convert($(this).val(), inputNumFormat, outputNumFormat, precisionCustomCurrent));
		});
		$("span.total").each(function(){
			outputNumFormat.precision = outputNumFormat.precision > 2 ? 2 : outputNumFormat.precision;
			$(this).html(NumberFormat.convert($(this).html(), inputNumFormat, outputNumFormat));
		});

        DocFormv2.updateSubTotal();
        DocFormv2.updateTotal(true);
        DocFormv2.updateAllRows(false);
	},

	initRowOptions: function(){

		$('#docForm .docrow').on('mouseenter', function() {

			if ($(this).find('.docQtip').find('.docQtip-line').length > 0 && $('#docForm').find('.ui-sortable-helper').length === 0){
				var panelSlideData = $('#pane-slider-right').data('panelSlide');
				var tmpQtip = $(this).find('.docQtip');

				if ($( window ).width() >= 1550){
					tmpQtip.removeClass('topRow');
					MyFacture.customForm('#' + this.id + ' .docQtip-line:eq(1)');
					tmpQtip.css('top', "-14");
				} else {
					tmpQtip.addClass('topRow');
					tmpQtip.css('top', "-"+tmpQtip.outerHeight()-10);
				}



				var qtipObj = $(this).find('.docQtip');

				if(qtipObj.hasClass('hiding')) {
					qtipObj.removeClass('hiding');
				}

				if(!$(this).hasClass('locked')) {
					// check if other are open, if yes, close them all !
					$('#formContent .docQtip').each(function() {
						var $qtip = $(this);
						if($qtip.is(":visible")) {
							$qtip.hide();
						}
					});

					// show the popup
					qtipObj.show();
				}

			}
		});

		$('#docForm .docrow').on('mouseleave', function(event){
			var $element = $(event.relatedTarget);
			var qtipObj = $(this).find('.docQtip');
			if (
				!qtipObj.hasClass('token-input-selected-dropdown-item') &&
				!qtipObj.hasClass('token_is_search') &&
				!qtipObj.hasClass('token-input-dropdown') &&
				!qtipObj.hasClass('token_is_hint') &&
				!qtipObj.closest('.ui-datepicker').length
			){

				if(!$(this).hasClass('locked')) {
					qtipObj.addClass('hiding');
					setTimeout(function() {
						if(qtipObj.hasClass('hiding')) {
							qtipObj.hide();
						}
					}, 3000);
				}
			}

		});

	},

	addRow: function(rowtype, beforeOrafter, fromPurchase){

		if(fromPurchase == undefined) {
			var action	= "doc";
			var context = "sales";
		}else {
			var action = "purchases_purchases";
			var context = "purchase";
		}

		if(rowtype === "catalogue"){
			if(context == 'sales'){
				Catalogue.loadCatalogue('doc', false, beforeOrafter, false);
			} else{
				Catalogue.loadCatalogue('doc', false, beforeOrafter, true);
			}

		} else if (rowtype == "onceDisabled"){
			return;
		} else {
			var data = {action:"addRow", rowtype: rowtype, doctype: this.doctype, rateCategory : this.rateCategory, doclang: this.doclang, thirdid: $('#thirdid').val(), doubleVat: DocFormv2.doubleVat};
			data = $.extend(true, data, DocFormv2.getNumFormat(true));

			MyFacture.post(action, data, function(data){

				DocFormv2.addRowCallback(data, beforeOrafter);
				switch(rowtype) {
					case 'packaging':
							DocFormv2.changeItem($('#docForm .docrow.packaging:last select.packaging').attr('id'));
							$('#docForm .docrow.packaging:last select.packaging').trigger('change');
						break;
					case 'shipping':
							DocFormv2.changeItem($('#docForm .docrow.shipping:last select.shipping').attr('id'));
							$('#docForm .docrow.shipping:last select.shipping').trigger('change');

							// it's an hidden field used by promotion module
							if($('input[name="isShippingFreeForPromotion"]').val() == 'Y'){
								DocFormv2.setShippingRowsAsFreeForPromotion();
							}

						break;
					default:
						break;
				}
			}, "html");
		}

    },

	addRowCallback: function(data, beforeOrafter){

		if (typeof data === 'function') return;

		var rowscounter = parseInt(Persistent.get("rowscounter"))+1;
		Persistent.set("rowscounter", rowscounter);
		data = data.replace('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>', "");
		var $row = $(Text.replace(data, "%rowposition%", rowscounter));
		$row.attr('id', "row_"+rowscounter);
		$row.html(Text.replace($row.html(),'%currency%', this.numformat.currency));

		if (beforeOrafter === undefined){
			$row.appendTo("#formContent");
		} else {
			var ref = $('#row_'+beforeOrafter.rowid);
			if (beforeOrafter.before === 'Y'){
				ref.before($row);
			} else {
				ref.after($row);
			}
			DocFormv2.updateRank();
			DocFormv2.updateSubTotal();
		}

		var show2ndTva = false;

		// Column display (or not)
		$("input.displayColumns").each(function(){
			var check	= $(this).prop('checked');
			var colname = $(this).attr('col');

			var invert	= ($(this).attr('invert') == undefined) ? false : true;

			if((check && invert) || (!check && !invert)) {
				switch(DocFormv2.columnsDisplay[colname]) {
					case 'hidden':
						$row.find('.'+colname).attr('style', 'display: table-cell').show();
						break;
					default:
						if(colname === 'discount') {
							if($('#discountByRows').prop('checked')) {
								$row.find('.'+colname).removeClass(DocFormv2.columnsDisplay[colname]).show();
							} else {
								$row.find('.'+colname).hide();
							}
						} else {
							$row.find('.'+colname).removeClass(DocFormv2.columnsDisplay[colname]).show();
						}
						break;
				}
			}else{
				switch(DocFormv2.columnsDisplay[colname]) {
					case 'hidden':
						$row.find('.'+colname).hide();
						break;
					default:
						if(colname === 'discount') {
							if($('#discountByRows').prop('checked')) {
								$row.find('.'+colname).removeClass(DocFormv2.columnsDisplay[colname]).show();
							} else {
								$row.find('.'+colname).hide();
							}
						} else {
							$row.find('.'+colname).addClass(DocFormv2.columnsDisplay[colname]).show();
						}
						break;
				}
			}
		});

		if(DocFormv2.doubleVat) {
			$row.find('.tax2').attr('style', 'display: table-cell').show();

			if($('#hideColumnTax').prop('checked')) {
				$row.find('.tax2').addClass(DocFormv2.columnsDisplay['tax2']);
			} else {
				$row.find('.tax2').removeClass(DocFormv2.columnsDisplay['tax2']);
			}
		} else {
			$row.find('.tax2').hide();
		}
		if($('#docAnalyticsCode').length > 0){
			$('#row_analyticsCode_'+rowscounter).val($('#docAnalyticsCode').val());
		}

		$(".noDocument:visible").hide();

		MyFacture.customForm("#row_"+rowscounter);
		Qtip.init();

		var rowtype = $("#row_type_"+rowscounter).val();

		var elemtId = "";
		var updateTax = false;
		var updateTax2 = false;

		switch(rowtype){
			case 'once':
				elemtId = "row_unit_"+rowscounter;
				$("#"+elemtId).val(DocFormv2.getDefaultUnit());
				$("#"+elemtId).trigger('change');
				updateTax = true;
				updateTax2 = true;
				break;
			case 'sum':
				DocFormv2.updateSubTotal();
				break;
			case 'packaging' :
				elemtId = "row_packaging_"+rowscounter;
				$("#"+elemtId).val(DocFormv2.getDefaultPackaging());
				$("#"+elemtId).trigger('change');
				updateTax2 = true;
				break;
			case 'shipping' :
				elemtId = "row_shipping_"+rowscounter;
				$("#"+elemtId).val(DocFormv2.getDefaultShipping());
				$("#"+elemtId).trigger('change');
				updateTax2 = true;
				break;
			case 'item' :
				DocFormv2.updateTotal();
				DocFormv2.updateSubTotal();
				// updateTax = true;
				updateTax2 = true;
				break;
		}

		if(updateTax && this.vat){
			elemtId = "row_tax_"+rowscounter;
			if($row.find('.tax').css('display') === 'none'){
				$("#"+elemtId).find('option[value='+DocFormv2.getDefaultTax()+']').attr('selected', 'true');
			}else{
				$("#"+elemtId).val(DocFormv2.getDefaultTax());
			}
		}

		if(updateTax2 && this.doubleVat){
			elemtId = "row_tax2_"+rowscounter;
			var tax2Display = $row.find('.tax2').css('display');

			// When table is already present, don't modify the DOM
			if (tax2Display == 'table-cell') {
				return;
			}

			if(tax2Display == 'none'){
				$("#"+elemtId).find('option[value='+DocFormv2.getDefaultTax2()+']').attr('selected', 'true');
			}else{
				$("#"+elemtId).val(DocFormv2.getDefaultTax2());
			}
		}

		var qt = $row.find('#row_qt_toCompute'+rowscounter).val();
		$row.find('#row_qt_'+rowscounter).val(NumberFormat.formatToDisplay(qt, this.getNumFormat(true), undefined, 'qt'));

		DocFormv2.updateRowEInvoicingConformity($row);
		DocFormv2.updateProductsCharacteristics();
		DocFormv2.checkForLockedRows();

		return rowscounter;

	},

	recordCatalogueCallback: function(data, afterOptions){

		var formIsOk = MyForm.processJson(data, "docCatalogueForm");

		if(formIsOk){
			if(data.rows){
				var catalogcallback = '';
				if ($('#catalogcallback').length > 0) {
					catalogcallback = $('#catalogcallback').val();
					eval(catalogcallback)(data.rows);
				} else {
					var rowscounter = parseInt(Persistent.get("rowscounter"));
					Persistent.set("rowscounter", rowscounter+(data.nb ? data.nb*1 : 0));
					for(var i = 0; i < data.rows.length ; i++){
						DocFormv2.addRowCallback(data.rows[i], afterOptions);
					}
				}
				DocFormv2.checkForLockedRows();
				DocFormv2.checkImpactStock();
			}

			MyWindow.close();

		}
	},

	changeItem: function(itemsListId){

		var parts		= itemsListId.split("_");
		var itemsList	= parts[parts.length-2];
		var position	= parts[parts.length-1];
		var rowId		= "row_"+position;

		if(Utils.exists(rowId)){

			$("#"+rowId).removeClass("form_warn_change");
			var selected = $("#"+itemsListId+" option:selected");

			$("#row_unitAmount_"+position).val(selected.attr("unitAmount"));
			$("#row_unitAmountDisplay_"+position).val(selected.attr("unitAmount"));

			if($("#docAnalyticsCode").length == 0){
				$("#row_analyticsCode_"+position).val(selected.attr("analyticsCode"));
			}else{
				$("#row_analyticsCode_"+position).val($("#docAnalyticsCode").val());
			}

			$("#row_qt_"+position).val(selected.attr("qt"));

			if(this.vat){
				$("#row_tax_"+position).val(selected.attr("taxid"));
			}

		}

	},

	computeMarge: function(type, rowID){

		DocFormv2.getNumFormat(true);
		var displayPurchaseAmount = $(rowID).find('input.purchasePrice').val();
		var purchaseAmount = new Big(NumberFormat.formatToFloat(''+displayPurchaseAmount, this.getNumFormat(true)));

		var displayAmount = $(rowID).find('input.unitAmountDisplay').val();
		var unitAmount = new Big(NumberFormat.formatToFloat(''+displayAmount, this.getNumFormat(true)));

		var newUnitAmount = unitAmount;
		switch (type){

			case "tauxMarque":

				var displayTauxMarque = $(rowID).find('input.tauxMarque').val();
				var tauxMarque = new Big(NumberFormat.formatToFloat(''+displayTauxMarque, this.getNumFormat(true)));
				var divider = Big(100).minus(tauxMarque);
				if (divider !== 0){
					newUnitAmount = purchaseAmount.times(100).div(divider);
				} else {
					newUnitAmount = 0;
				}
				break;

			case "tauxMarge":

				var displayTauxMarge = $(rowID).find('input.tauxMarge').val();
				var tauxMarge = new Big(NumberFormat.formatToFloat(''+displayTauxMarge, this.getNumFormat(true)));
				tauxMarge = tauxMarge.div(100);
				newUnitAmount = tauxMarge.times(purchaseAmount).plus(purchaseAmount);

				break;

		}

		$(rowID).find('input.unitAmountDisplay').val(NumberFormat.formatToDisplay(newUnitAmount, this.getNumFormat(), undefined, 'unitAmount'));
		DocFormv2.updateRow(rowID);

	},

	updateAllRows : function(updateTotal){
		updateTotal = (undefined == updateTotal) ? true : updateTotal;

        $('#formContent .row.computable, #formContent .row.shipping, #formContent .row.packaging').each(function(){
			DocFormv2.updateRow('#'+$(this).attr('id'), updateTotal)
		});
	},

	updateRow : function(rowID, updateTotal){
		let $row = $(rowID);

		updateTotal = (undefined == updateTotal) ? true : updateTotal;

		let numformat				= DocFormv2.getNumFormat(true);
		let displayAmount			= $row.find('input.unitAmountDisplay').val();
        let unitAmount = NumberFormat.formatToFloat(displayAmount, numformat);
        if (isNaN(unitAmount)) {
            unitAmount = 0;
            $row.find('input.unitAmountDisplay').val(unitAmount)
        }
        unitAmount = new Big(unitAmount);

		let displayPurchaseAmount	= $row.find('input.purchasePrice').val();

        let purchaseAmount = new Big(0)
		if (displayPurchaseAmount !== undefined){
			purchaseAmount = new Big(NumberFormat.formatToFloat(''+displayPurchaseAmount, numformat));
		}

		let ecoTax = new Big(0);
        const ecoTaxType = $row.find('.ecoTaxType').val()
		if ($row.find('input.ecoTaxDisplay').length > 0){
			let displayEcoTax	= $row.find('input.ecoTaxDisplay').val();
			ecoTax				= new Big(NumberFormat.formatToFloat(''+displayEcoTax, numformat));
		}

		let $qty		= $('input.quantity', $row);
        let displayQty	= $qty.val();
		let qtIntOnly	= $qty.hasClass('intOnly');
        let quantity	= NumberFormat.formatToFloat(''+displayQty, numformat);
        if (isNaN(quantity)) {
            quantity = 0;
            $qty.val(quantity);
        }

		if (qtIntOnly){
			quantity	= Math.round(quantity);
			displayQty	= NumberFormat.formatToDisplay(quantity, numformat);
		}

        const selectedTaxOption = $row.find('.tax select option:selected');
        const taxRateDisplay	= selectedTaxOption.attr('rate');

        DocFormv2.updateRowEInvoicingConformity($row);
		let taxRate			= new Big(NumberFormat.formatToFloat(''+taxRateDisplay, numformat));

		let hasDiscountByRow	= $('input[name=discountByRows]').prop('checked');
		let discount			= new Big(NumberFormat.formatToFloat($row.find('input.discountValue').val(), numformat));
		let discountUnit		= $row.find('select.discountUnit').val();

		let precisionUnitAmount = numformat.precision;
		if ((typeof numformat.precisioncustom.unitAmount != 'undefined') && (numformat.precisioncustom.unitAmount !== 'default')) {
			precisionUnitAmount = parseInt(numformat.precisioncustom.unitAmount);
		}

        let precisionQuantity = numformat.precision;
        if ((typeof numformat.precisioncustom.qt != 'undefined') && (numformat.precisioncustom.qt !== 'default')) {
            precisionQuantity = parseInt(numformat.precisioncustom.qt);
        }

        const entry = {
            unitAmount,
            ecoTax: ecoTaxType ? {type: ecoTaxType, value: ecoTax} : null,
            quantity: new Big(quantity),
            taxRate,
            discount: hasDiscountByRow ? {
                type: discountUnit,
                value: discount
            } : null
        };

        const config = {
            precisionDocument: numformat.precision,
            precisionUnitAmount,
            precisionQuantity,
            isTaxesInc: this.isTaxesInc,
            hasVat: DocFormv2.vat,
            ecoTaxRate: this.ecoTax?.rate ? new Big(this.ecoTax.rate) : null
        }

        let {
            total,
            unitHT,
            unitTTC,
            ecoTaxHT,
            totalEcoTax,
        } = this.formula.computeRow(entry, config);

		// affect right value on right place
		$row.find('.unitAmount').val(unitHT);
		$row.find('.unitAmountTaxesInc').val(unitTTC);
		$qty.val(displayQty);

		let $discountValue = $row.find('.discountValue');
		if (discountUnit === 'percent') {
			$discountValue.removeAttr('e_formatnum_precisioncustom');
		} else {
			$discountValue.attr('e_formatnum_precisioncustom', 'unitAmount');
		}
		$discountValue.val(NumberFormat.formatToDisplay(discount, numformat, undefined, $discountValue.attr('e_formatnum_precisioncustom')));

		$row.find('.total').html(NumberFormat.formatToDisplay(total, numformat));
		$row.find('.totalAmount').val(total);

		$row.find('.ecoTax').val(ecoTaxHT);

		$row.find('.totalEcoTax').html(NumberFormat.formatToDisplay(totalEcoTax, numformat));
		$row.find('.totalEcoTaxAmount').val(totalEcoTax);


		// Calc Taux de marque + Taux de marge
		let tauxMarque	= Big(0);
		let tauxMarge	= Big(0);

		if (hasDiscountByRow) {
			if (discountUnit === 'percent') {
				let discountedUnitAmountHT = unitHT.times(discount).div(100).round(numformat.precision);
                unitHT = unitHT.minus(discountedUnitAmountHT);
			} else {
                unitHT = unitHT.minus(discount);
			}
		}

		let marge	= unitHT.minus(purchaseAmount);

		if (unitHT.toString() != 0){
			tauxMarque	= marge.div(unitHT).times(100);
		}
		if (purchaseAmount.toString() != 0){
			tauxMarge	= marge.div(purchaseAmount).times(100);
		}

		$row.find('.tauxMarque').val(NumberFormat.formatToDisplay(tauxMarque.round(2), numformat));
		$row.find('.tauxMarge').val(NumberFormat.formatToDisplay(tauxMarge.round(2), numformat));

		if(updateTotal) {
			this.updateTotal();
		}

		this.updateSubTotal();

	},

	updateSubTotal: function(){

		$('#formContent div.sum').each(function(){
			var total = new Big(0);
			$(this).prevAll('div.row').each(function(){
				if($(this).hasClass('computable') || ($(this).hasClass('shipping') || $(this).hasClass('packaging')) && ! $('tr.optional', this).length){
					var totalLine = $(this).find('.totalAmount').val();
					total = total.plus(totalLine);
				} else if($(this).hasClass('sum')){
					return false;
				}
				return true;
			});
			$(this).find('.amount span.total').html(NumberFormat.formatToDisplay(total.toString(), DocFormv2.getNumFormat(true)));
		});

	},

	updateTotal : function(force){

        // Reset OverrideTotals
        $('.override-totals-editable').hide();
        $('.override-totals-no-editable').show();

		force		= typeof force !== 'undefined'	? force	: false;
		if(!force && nbRows > 150) {
			$("#calcTotalsButton a .fa").attr('class', 'fa fa-circle-o-notch fa-spin fa-15');
		}

		var nbRows	= $('#formContent .row.computable, #formContent .row.shipping, #formContent .row.packaging').length;

		if(!force && nbRows > 150) {
			DocFormv2.switchTotals(false);
			return false;
		}

		if(DocFormv2.isTaxesInc){
			DocFormv2.computeTaxesIncTotal();
		}else{
			DocFormv2.computeTaxesFreeTotal();
		}

		$('input[name=totalDue]').val(DocFormv2.totalDue);
		$('td.totalDue').html(NumberFormat.formatToDisplay(DocFormv2.totalDue, DocFormv2.numformat));
		DocFormv2.computePayDeadlinesTotal();

		// reset color & button
		DocFormv2.switchTotals(true);

		$("#calcTotalsButton a .fa").attr('class', 'fa fa-money fa-15');

		// Check if overrideTotals
        this.checkOverrideTotals();
	},

	switchTotals : function(blinkTotals) {
		var button = $('#calcTotalsButton');
		if(blinkTotals) {
			$('.listTotal *').css('color', '#000');
			button.hide();
		} else {
			$('.listTotal *').css('color', '#EDECEC');
			button.show();

		}
	},

	computeTaxesIncTotal : function(){
		var _this = this;
		const documentNumFormat = {...DocFormv2.getNumFormat(true)}; // cloning
		var precision = this.numformat.precision > 2 ? 2 : this.numformat.precision;
		var discount		= new Big(NumberFormat.formatToFloat($('input[name=globalDiscount]').val(), DocFormv2.getNumFormat()));
		var discountUnit	= $('select[name=globalDiscountUnit]').val();

        const entry = {
            discount: {
                type: discountUnit,
                value: discount
            },
            rows: [],
            documentEcoTax: this.ecoTax?.id ? {
                rate: new Big(this.ecoTax.rate),
                id: this.ecoTax.id,
                label: this.ecoTax.label
            } : null,
            relatedAmounts: this.relatedsAmount
        }
        const config = { precision }

		// Collect totalAmounts (TTC) and compute VAT Bases
		$('#formContent .row.computable, #formContent .row.shipping, #formContent .row.packaging').each(function(){
			let totalLine = new Big($(this).find('.totalAmount').val());

            let taxRateDisplay	= $(this).find('.tax select option:selected').attr('rate');
            let taxLabel		= $(this).find('.tax select option:selected').html();
            let taxid			= $(this).find('.tax select').val();

			if(taxLabel !== undefined){
				let taxLabelParts = taxLabel.split(' - ');
				if(taxLabelParts.length > 1){
					taxLabel = taxLabelParts[0];
				}else{
					taxLabel = "";
				}
			}else{
				taxLabel = "";
			}

			let taxRate = NumberFormat.formatToFloat(''+taxRateDisplay, DocFormv2.getNumFormat());

            let rowType = '';
            let ecoTax = null;
            if($(this).hasClass('computable')){
                rowType = 'item';
                let totalEcoTaxeLine = new Big(0);
                if ($(this).find('.totalEcoTaxAmount').val() !== ""){
                    totalEcoTaxeLine = new Big($(this).find('.totalEcoTaxAmount').val());
                }
                ecoTax = {
                    value: totalEcoTaxeLine,
                    type: $(this).find('.ecoTaxType').val()
                }
            }else if($(this).hasClass('shipping') && ! $('tr.optional', this).length){
                rowType = 'shipping';
            }else if($(this).hasClass('packaging') && ! $('tr.optional', this).length){
                rowType = 'packaging';
            }

            entry.rows.push({
                totalLine,
                ecoTax,
                tax: taxid ? {
                    rate: new Big(taxRate),
                    id: taxid,
                    label: taxLabel
                } : null,
                type: rowType,
            });
		});

        const {
            totalDue,
            totalAmountAllCases,
            taxes,
            totalHT,
            totalTTC,
            totalShipping,
            totalPackaging,
            totalDiscounted,
            totalEcoTax,
            totalAllInc,
            globalDiscount
        } = this.formula.computeTaxesIncTotal(entry, config);

        let numFormat = {...this.getNumFormat(true)};
        numFormat.precision = +numFormat.precision === 0 ? 0 : 2;

		$('#taxesTotals tr').each(function(){
			var id = $(this).attr('id').split('_');
			if(id[1] !== undefined && taxes.get(id[1]) !== undefined){
				$(this).find('.total').html(NumberFormat.formatToDisplay(taxes.get(id[1]).amount.toString(), numFormat, true));
				$(this).show();

			} else{
				$(this).find('.total').html(NumberFormat.formatToDisplay(0,  DocFormv2.numformat));
				$(this).hide();
			}
		});

		$("#totalAmount .total").html(NumberFormat.formatToDisplay(totalTTC.toString(), numFormat, true));

		_this.subTotal = totalHT.toString();
		$('input[name="subTotalExclTax"]').val(totalHT.toString());
		$("#totalAmountTaxEcl .total").html(NumberFormat.formatToDisplay(totalHT.toString(), numFormat, true));

		DocFormv2.formatDiscount();

		if(globalDiscount.percent.gt(0)){
			$('#totalDiscount .title span').html(NumberFormat.formatToDisplay(globalDiscount.percent.toString(), numFormat, true));
			$('#totalDiscount .total').html(NumberFormat.formatToDisplay(globalDiscount.amount.toString(), numFormat, true));
			$('#totalDiscount_step .total').html(NumberFormat.formatToDisplay(totalDiscounted.toString(), numFormat, true));

			$('#totalDiscount:hidden').show();
			$('#totalDiscount_step:hidden').show();
		}else{
			$('#totalDiscount').hide();
			$('#totalDiscount_step').hide();
		}

		if(totalShipping > 0){
			$('#totalShipping .total').html(NumberFormat.formatToDisplay(totalShipping.toString(), numFormat, true));
			$('#totalShipping:hidden').show();
		}else{
			$('#totalShipping').hide();
		}

		if(totalPackaging > 0){
			$('#totalPackaging .total').html(NumberFormat.formatToDisplay(totalPackaging.toString(), numFormat, true));
			$('#totalPackaging:hidden').show();
		}else{
			$('#totalPackaging').hide();
		}

		if (totalEcoTax > 0){
			$('#totalAllEcoTax .total').html(NumberFormat.formatToDisplay(totalEcoTax, this.numformat, true));
			$('#totalAllEcoTax').show();
		} else {
			$('#totalAllEcoTax').hide();
		}

		$('#totalTaxesFree .total').html(NumberFormat.formatToDisplay(totalHT.toString(), numFormat, true));
        $('#totalAllInc .total').html(NumberFormat.formatToDisplay(totalAllInc.toString(), numFormat, true));

		if(this.hasRelateds){
			$('#totalDue span.total').html(NumberFormat.formatToDisplay(totalDue.toString(), numFormat, true));
			$('#totalDue:hidden').show();
		}else{
			$('#totalDue .total').html(NumberFormat.formatToDisplay(totalDue.toString(), numFormat, true));
		}

		DocFormv2.totalDue = totalDue;
        $('#totalAmountAllCases').val(totalAmountAllCases.toString());
	},

	computeTaxesFreeTotal : function() {
		const _this = this;
		const documentNumFormat = JSON.parse(JSON.stringify(DocFormv2.getNumFormat(true))); // cloning
		this.numformat.precision = this.numformat.precision > 2 ? 2 : this.numformat.precision;

        let discount = new Big(NumberFormat.formatToFloat($('input[name=globalDiscount]').val(), DocFormv2.getNumFormat()));

        let discountUnit = $('select[name=globalDiscountUnit]').val();
        const entry = {
            discount: {
                type: discountUnit,
                value: discount
            },
            rows: [],
            documentEcoTax: this.ecoTax?.id ? {
                rate: new Big(this.ecoTax.rate),
                id: this.ecoTax.id,
                label: this.ecoTax.label
            } : null,
            relatedAmounts: this.relatedsAmount
        }
        const config = { precision: this.numformat.precision, hasVat: DocFormv2.vat }

		// Collect totalAmounts (HT) and compute VAT Bases
		$('.docrow', '#formContent').each(function() {
			let rowType = '';
			if($(this).hasClass('computable')){
				rowType= 'item';
			}else if($(this).hasClass('shipping') && ! $('tr.optional', this).length){
				rowType= 'shipping';
			}else if($(this).hasClass('packaging') && ! $('tr.optional', this).length){
				rowType= 'packaging';
			}

            let totalLine = new Big(0);
			if(rowType !== ''){
				let rawTotalLine = $(this).find('.totalAmount').val();

				if (isNaN(rawTotalLine)) {
					rawTotalLine = 0;
				}

                totalLine = new Big(rawTotalLine);
			}

			if($(this).hasClass('option')){
                return;
			}

            let taxRateDisplay, taxLabel, taxid, taxRate = "";

            const row = {
                totalLine,
                ecoTax: null,
                tax: null,
                tax2: null,
                type: rowType,
            }

			// Get all taxes of the line
			if(DocFormv2.vat && rowType !== ''){
                taxRateDisplay	= $(this).find('.tax').find('select').find('option:selected').attr('rate');
                taxLabel		= $(this).find('.tax').find('select').find('option:selected').html();
                taxid			= $(this).find('.tax').find('select').val();

				var taxLabelParts = '';
				taxLabelParts = taxLabel ? taxLabel.split(' -') : [];
                if(taxLabelParts.length > 1){
                    taxLabel = taxLabelParts[0];
                }else{
                    taxLabel = "";
                }

                taxRate = NumberFormat.formatToFloat(''+taxRateDisplay, DocFormv2.getNumFormat());

                row.tax = taxid ? {
                    rate: new Big(taxRate),
                    id: taxid,
                    label: taxLabel
                } : null;

				if (DocFormv2.doubleVat) {
					var tax2RateDisplay = $(this).find('.tax2').find('select').find('option:selected').attr('rate');
					var tax2Label = $(this).find('.tax2').find('select').find('option:selected').html();
					var taxLabelParts = '';
					taxLabelParts = tax2Label ? tax2Label.split(' -') : [];

					if (taxLabelParts.length > 1) {
						taxLabel = taxLabelParts[0];
					} else {
						taxLabel = "";
					}

					var tax2id = $(this).find('.tax2').find('select').val();
					var tax2Rate = NumberFormat.formatToFloat('' + tax2RateDisplay, DocFormv2.getNumFormat());

                    row.tax2 = tax2id ? {
                        rate: new Big(tax2Rate),
                        id: tax2id,
                        label: taxLabel
                    } : null;
				}
            }

            if(rowType === 'item') {
                let totalEcoTaxeLine = new Big(0);
                if ($(this).find('.totalEcoTaxAmount').val() !== ""){
                    totalEcoTaxeLine = new Big($(this).find('.totalEcoTaxAmount').val());
                }
                row.ecoTax = {
                    value: totalEcoTaxeLine,
                    type: $(this).find('.ecoTaxType').val()
                }

                if(DocFormv2.vat){
                    // eco tax ? reduce base VAT with eco Tax and add ecoTax to a specific taxRate
                    if (totalEcoTaxeLine > 0){

                        if($(this).find('.ecoTaxType').val() === "inc") {
                            $(this).find('.ecotaxTypeLabel').html(Loc.g('dont écotaxe'));
                        }else {
                            $(this).find('.ecotaxTypeLabel').html(Loc.g('écotaxe en sus'));
                        }
                    }
                }
            }

            if (row.rowType !== '') {
                entry.rows.push(row);
            }
		});

        const {
            totalDue,
            taxes,
            totalHT,
            totalTTC,
            totalShipping,
            totalPackaging,
            totalDiscounted,
            totalHTNet,
            totalEcoTax,
            globalDiscount
        } = this.formula.computeTaxesFreeTotal(entry, config);
		// compute VAT Values
		if(DocFormv2.vat){
			$('.totalTaxes', '#taxesTotals').each(function() {
				var id = $(this).attr('id').split('_');

				if(id[1] !== undefined && taxes.get(id[1]) !== undefined){
					var numformat = DocFormv2.getNumFormat();
					numformat.precision = numformat.precision > 2 ? 2 : numformat.precision;

					var amountFormatted = NumberFormat.formatToDisplay(taxes.get(id[1]).amount.toString(), DocFormv2.numformat, true);

					$('td.tamount', this).find('span.total').text(amountFormatted);
					$(this).show();
				} else {
					$(this).filter(':visible').hide().find('span.total').text(NumberFormat.formatToDisplay(0,  DocFormv2.numformat, true));
				}
			});
		}else{
			$('#taxesTotals').find('tr').hide();
		}

		if(globalDiscount.percent.gt(0)){
			$('#totalDiscount').find('.title span').html(NumberFormat.formatToDisplay(globalDiscount.percent.toString(), this.numformat, true));
			$('#totalDiscount').find('.total').html(NumberFormat.formatToDisplay(globalDiscount.amount.toString(), this.numformat, true));
			$('#totalDiscount_step .total').html(NumberFormat.formatToDisplay(totalDiscounted.toString(), this.numformat, true));

			$('#totalDiscount:hidden').show();
			$('#totalDiscount_step:hidden').show();
		}else{
			$('#totalDiscount').hide();
			$('#totalDiscount_step').hide();
		}

		_this.subTotal = totalHT.toString();
		$('input[name="subTotalExclTax"]').val(totalHT.toString());

		$('#totalTaxesFree').find('.total').html(NumberFormat.formatToDisplay(totalHT.toString(), this.numformat, true));
		$('#totalTaxesFree:hidden').show();

		if(totalShipping > 0){
			$('#totalShipping').find('.total').html(NumberFormat.formatToDisplay(totalShipping.toString(), this.numformat, true));
			$('#totalShipping:hidden').show();
		}else{
			$('#totalShipping').hide();
		}

		if(totalPackaging > 0){
			$('#totalPackaging').find('.total').html(NumberFormat.formatToDisplay(totalPackaging.toString(), this.numformat, true));
			$('#totalPackaging:hidden').show();
		}else{
			$('#totalPackaging').hide();
		}

		if(totalHTNet.toString() !== totalDiscounted.toString() || totalEcoTax.toString() > 0) {
			$('#totalTaxesFree_step').find('.total').html(NumberFormat.formatToDisplay(totalHTNet.toString(), this.numformat, true));
			$('#totalTaxesFree_step:hidden').show();
		}else{
			$('#totalTaxesFree_step').hide();
		}

		if (totalEcoTax > 0){
			$('#totalAllEcoTax').find('.total').html(NumberFormat.formatToDisplay(totalEcoTax.toString(), this.numformat, true));
			$('#totalAllEcoTax').show();
		} else {
			$('#totalAllEcoTax').hide();
		}

		$('#totalAllInc').find('.total').html(NumberFormat.formatToDisplay(totalTTC.toString(), this.numformat, true));

		if(this.hasRelateds){
			$('#totalDue').find('span.total').html(NumberFormat.formatToDisplay(totalDue.toString(), this.numformat, true));
			$('#totalDue:hidden').show();
		}

        DocFormv2.totalDue = totalDue;

        $('#totalAmountAllCases').val(totalTTC.toString());
	},


    deleteRow: function(rowid, updateTotal){
		updateTotal = updateTotal == undefined ? true : updateTotal;

         $('#row_'+rowid).slideUp(200, function() {
            $('#row_'+rowid).remove();
			DocFormv2.updateRank();
			if(updateTotal) {
				DocFormv2.updateSubTotal();
				DocFormv2.updateTotal();
				DocFormv2.updateProductsCharacteristics();
			}

			if($('#formContent .docrow').length == 0) {
				$(".noDocument").slideDown(200);
			}

			DocFormv2.checkImpactStock();
         });
    },

	updateRank: function(){
	     var rank=1;
		 $('#formContent .rankForm').each(function(){
			 $(this).val(rank);
			 rank++;
		 });
	},

	getProperties : function(search){
		var toSearch = [];
		if(typeof search == 'string'){
			toSearch.push(search);
		}else if(typeof search == "object"){
			toSearch = search;
		}

		var properties = [];
		for(var propertyName in DocFormv2) {
			if(typeof DocFormv2[propertyName] != 'function'){
				if(toSearch.length == 0){
					properties[propertyName] = DocFormv2[propertyName];
				}else if(toSearch.length != 0 && Utils.in_array(propertyName, toSearch)){
					properties[propertyName] = DocFormv2[propertyName];
				}
			}
		 }
		 return $.extend({}, properties);
	},

	toggleOption : function(rowid, position, optionToSet){

		if (optionToSet === undefined){
			var optionToSet = $('#'+rowid).find('input[name=row_isOption_'+position+']').val();
		}
		if(optionToSet == 'Y'){
			$('#'+rowid).find('input[name=row_isOption_'+position+']').val('N');
			if($('#'+rowid).hasClass('shipping')||$('#'+rowid).hasClass('packaging')){
				$('#'+rowid).find('tr:first').removeClass('primary-50');
			} else {
				$('#'+rowid).addClass('computable').find('tr:first').removeClass('primary-50');
			}
			$('#'+rowid).find('tr:first').removeClass('optional');
		}else{
			$('#'+rowid).find('input[name=row_isOption_'+position+']').val('Y');
			$('#'+rowid).removeClass('computable').find('tr:first').addClass('primary-50 optional');
		}
		DocFormv2.updateSubTotal();
		DocFormv2.updateTotal();
		DocFormv2.updateProductsCharacteristics();
	},

	validation: function () {
		var options = {
			type			: 'warning',
			title			: Loc.g("Finalisation de votre document"),
			noclose			: true,
			closeOnEscape	: function(){$(this).dialog("close");},
			width			: 600,
			buttons			: [
				{text : Loc.g("Annuler"), click : function(){
					$(this).dialog("close");
				}},
				{text : Loc.g("Finaliser"), click : function(){
					// Destroy this popup because next popup (with redirection) won't trigger 'open' method.
					MyWindow.close('alertWindow')
					DocFormv2.record('validate')
				}}
			]
		};

		var $datepicker = $('#displayedDate').clone().removeAttr('id').removeClass('hasDatepicker').css({'vertical-align' : 'middle', 'width': '96px'});

		if (this.doctype == 'invoice') {
			MyWindow.alert(
				window.i18n.__('Cette action va transformer votre brouillon en facture en date du %(datePicker)s', {"datePicker": `<span class="ml-2">` +
				$datepicker[0].outerHTML +
				`</span><br><br>` }) +
				window.i18n.__('Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre facture prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires.'),
				options
			);
		} else if (this.doctype == 'creditnote') {
			MyWindow.alert(
				window.i18n.__('Cette action va transformer votre brouillon en avoir en date  du %(datePicker)s', {"datePicker": `<span class="ml-2">` +
				$datepicker[0].outerHTML +
				`</span><br><br>` }) +
				window.i18n.__('Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre avoir prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires.'),
				options
			);
		}

		var inputWithDatePicker = $('#alertWindow input.hasDatePicker[name=displayedDate]')
			.change(function() {document.getElementById('displayedDate').value = this.value;});

		var dateFormat	= "dd/mm/yy";
		if (inputWithDatePicker.attr('format') == 'mdy') {
			dateFormat = "mm/dd/yy";
		}

		inputWithDatePicker.datepicker('option', 'dateFormat', dateFormat);
		if ($datepicker.attr('mindate') !== undefined) {
			inputWithDatePicker.datepicker('option', 'minDate', new Date($datepicker.attr('mindate')));
		}
		if ($datepicker.attr('maxdate') !== undefined) {
			inputWithDatePicker.datepicker('option', 'maxDate', new Date($datepicker.attr('maxdate')));
		}
		inputWithDatePicker.datepicker('setDate', new Date());
		inputWithDatePicker.change();
	},

	record: function(afterRecording){
		CheckAlive.forceCheck(function () {
			$('#docForm ul li.bDocFormSave a').attr('onclick', 'return false;');
			if (afterRecording !== undefined) {
				$("#afterRecording").val(afterRecording);
				Persistent.set('afterRecording', afterRecording);
			}
			MyFacture.startWait();
			$("#docForm").submit();
			$('#docForm ul li.bDocFormSave a').attr('onclick', 'DocFormv2.record();');
		});
	},

	recordCallback: function(data){
        try {
            JSON.parse(data);
        } catch (e) {
            MyFacture.stopWait();
			return false;
        }
		var data = $.parseJSON(data);

		var formIsOk = MyForm.processJson(data, "docForm");

		if(formIsOk){

            $("#docid").val(data.docid);

			var redirectAfter			= data.redirectAfterRecord;
			var autoUpdateStepAndAmount = data.autoUpdateStepAndAmount;
			var oppLinked				= data.oppLinked;

			var canwriteopp				= data.canwriteopp;

			if (autoUpdateStepAndAmount != undefined && !Feature.isEnabled('hide-doc-popup-manual-update-step-and-amount')) {

				var alertOption = {
					title			: Loc.g("Mise à jour des statuts"),
					width: 1200,
					open: function(){
						var formId = "manualUpdateStepAndAmountForm";
						var options = {success:function(data){
							MyWindow.awake('alertWindow')
							var formIsOk = MyForm.processJson(data, "manualUpdateStepAndAmountForm");
							if (formIsOk){
								Utils.relocate(redirectAfter);
							}
						}, dataType:"json"};

						var data = {action: 'recordManualUpdateStepAndAmountForm'};
						MyForm.prepare(formId, "doc&"+$.param(data), options, true);

						MyFacture.customForm('#manualUpdateStepAndAmountForm');

					},
					buttons	: [
						{
							text : Loc.g("Fermer"),
                            'class' : 'btn btn-default',
							click : function(){
								Utils.relocate(redirectAfter);
							}
						},
                        {
                            text : Loc.g("Appliquer les nouveaux statuts"),
                            'class' : 'btn btn-primary',
                            click : function(){
                                MyWindow.wait('alertWindow');
                                $("#manualUpdateStepAndAmountForm").submit();
                            }
                        },
                    ]
				};

				MyWindow.alert(autoUpdateStepAndAmount, alertOption);

			} else if (oppLinked != undefined && data.oppsIds != '') {
				var newDueDate = data.newDueDate;
				var oppsIds = data.oppsIds;
				var newAmount = data.newAmount;

				if (canwriteopp == 'Y') {
					DocFormv2.updateOppWithDocDataForm(newDueDate, oppsIds, newAmount, redirectAfter);
				} else if (redirectAfter != undefined) {
					Utils.relocate(redirectAfter);
				}
			} else if (redirectAfter != undefined) {
				Utils.relocate(redirectAfter);
			}
        } else {
			if(data.form.fields.length >= 1 && data.form.fields[0].fieldId === "checkIdentExist" && $("#checkDocIdent").val() === "y") {

				var options = {
					type			: 'warning',
					title			: Loc.g("Numéro de document existant"),
					noclose			: true,
					closeOnEscape	: function(){$(this).dialog("close");},
					width			: 600,
					buttons			: [
						{text : Loc.g("Enregistrer quand même le document"), click : function(){
							$("#checkDocIdent").val("n");
							$("#docForm").submit();
						}},
						{text : Loc.g("Modifier le document"), click : function(){
							$("#ident").focus();
							$(this).dialog("close");
						}},
						{text : Loc.g("Suivre la numérotation et enregistrer"), click : function(){
							$("#ident").val(data.newIdent);
							$("#identHasChanged").val(1);
							$("#docForm").submit();
						}}
					]
				};

				MyWindow.alert(Loc.g('Vous avez saisi un numéro de document existant. Souhaitez vous le modifier ?'), options);

			}else {

				var message = '';

				if(typeof(data.form.fields[0]) !== 'undefined'){
					var error = data.form.fields[0].fieldId;

					var parsed = error.split('_');
					if(parsed[0] === 'row') {
						error = parsed[1];
					} else {
						error = parsed[0];
					}
					switch(error) {
						case 'stockmove':
							message = Loc.g('Les mouvements de stocks ne peuvent être antérieurs à un inventaire');
							break;
						case 'analyticsCode':
							message = Loc.g('Le code analytique doit contenir entre 1 et 13 caractères');
							break;
						default:

							var errorMsg = "";
							$.each(data.form.fields, function(k,v){
								errorMsg += "<li> - " + v.msg + "</li>";
							});

							message = Loc.g('Votre document comporte des erreurs. Voici le détail :') + "<br /><br /><ul>" + errorMsg + "</ul>";
							break;
					}
				} else{
					message = Loc.g('Des champs personnalisés obligatoires ne sont pas renseignés.');
				}

				MyWindow.alert(message,{type:'error'});
			}

			MyFacture.stopWait();
        }
	},

    /**
	 *
     * @param newDueDate
     * @param oppsIds
     * @param newAmount
     * @param redirectAfter
     */
	updateOppWithDocDataForm : function(newDueDate,oppsIds,newAmount,redirectAfter){

		var options = {
			title   : Loc.g("Mise à jour des opportunités liées"),
			buttons : [
				{
					text : Loc.g("Ne rien faire"),
                    'class'	: 'btn btn-default',
					click : function(){
						$(this).dialog("close");
						Utils.relocate(redirectAfter);
					}
				},
                {
                    text : Loc.g("Mettre à jour"),
                    'class'	: 'btn btn-primary',
                    click    : function(){
                        $("#updateOppWithDocDataForm").submit();
                    }
                },
			],
			width: 800,
			callback    : function(){
				DocFormv2.prepareUpdateOppWithDocDataForm();
			}
		};

		var fileOpt = {action:"updateOppWithDocDataForm", newDueDate : newDueDate, oppsIds : oppsIds, newAmount : newAmount, redirectAfter: redirectAfter};
		MyWindow.load("prospection_opportunity", fileOpt, options);

	},

	prepareUpdateOppWithDocDataForm: function(){

		var formId = "updateOppWithDocDataForm";
		var options = {success:function(data){DocFormv2.recordUpdateOppWithDocDataCallback(data);}, dataType:"json"};
		var params = {action:'recordUpdateOppWithDocData'};
		MyForm.prepare(formId, "prospection_opportunity&"+$.param(params), options, true);
		MyFacture.initEvent("#updateOppWithDocDataForm");
	},

	recordUpdateOppWithDocDataCallback: function(data){
		if(data.status === "error"){
			MyWindow.close();
		} else {
			if(data.redirectAfter != ''){
                Utils.relocate(data.redirectAfter);
            } else{
				Utils.reload();
			}
		}
	},

	switchDoubleVat : function(){

		DocFormv2.doubleVat = $('#hasDoubleVat').is(':checked');
		var hideTax			= $('#hideColumnTax').is(':checked');
		var showTaxBasis	= $('#showTaxBasis');

		var doubleVat = $('.tax2');

		if(DocFormv2.doubleVat) {
			doubleVat.show();

			if($('#hideColumnTax').prop('checked')) {
				doubleVat.addClass(DocFormv2.columnsDisplay['tax2']);
			} else {
				doubleVat.removeClass(DocFormv2.columnsDisplay['tax2']);
			}

			MyFacture.customForm();
		} else {
			doubleVat.hide();
		}

		showTaxBasis.attr('disabled', DocFormv2.doubleVat);
		$('.alert.hasDoubleVat').toggleClass('hidden', !DocFormv2.doubleVat);

		DocFormv2.updateTotal();
	},

	switchEcoTaxes: function(){
		var newEcoTax = $('#ecoTaxForDoc option:selected');

		this.ecoTax.id = newEcoTax.attr('ecotaxid');
		this.ecoTax.label = newEcoTax.attr('ecotaxlabel');
		this.ecoTax.rate = newEcoTax.attr('value');

		$('input[name=ecoTaxId]').val(this.ecoTax.id);
		$('input[name=ecoTaxRate]').val(this.ecoTax.rate);
		$('input[name=ecoTaxLabel]').val(this.ecoTax.label);

		DocFormv2.updateTotal();

	},

	editPenaltyRetardWarning: function(){
		var options = {
			title	: Loc.g("Modifier le texte de loi"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){$(this).dialog("close")}},
				{
					text : "Modifier",
					click : function(){
						$("#penaltyform").submit();
					}
				}
			],
			callback	: function(){DocFormv2.preparePenaltyForm();}
		};

		MyWindow.load("prefsDocs", {action:"penatlyedit"}, options);
	},

	preparePenaltyForm: function(){

		var formId = "penaltyform";
		var options = {success:function(data){DocFormv2.callbackPenaltyForm(data);}, dataType:"json"};
		var data = {action: 'penaltysave'};
		MyForm.prepare(formId, "prefsDocs&"+$.param(data), options, true);
		MyFacture.initEvent();

	},

	callbackPenaltyForm: function(data){

		MyForm.processJson(data, "penaltyform");
		if("ok"!=data.form.status){
			return false;
		}

		var penaltyText = data.penaltyRetardWarningText;
		$('.hasPenaltyRetardWarning-label').html(penaltyText);

		MyWindow.close();
		return true;
	},

	formatDiscount: function() {
		$('input.discountValue').each(function(i,e) {
			var current = $(e);
			var currentVal = NumberFormat.formatToDisplay(current.val(), DocFormv2.getNumFormat(true));

			current.val(currentVal);
		});
	},

	updateDiscountByRows : function(element) {

		var checked					= element.prop('checked');
		var hideColumn				= $('#hideColumnDiscount');
		var discountChecked			= hideColumn.prop('checked');
		var discountColumn			= $('th.discount');

		if(checked) {
			// discount by rows activated
			discountColumn.show();
			if(discountChecked) {
				discountColumn.find('span.eye-container').html('<i class="fa fa-eye"></i>');
			} else {
				discountColumn.find('span.eye-container').html('<i class="fa fa-eye-slash eye-disabled"></i>');
			}
		} else {
			// discount by rows not activated
			discountColumn.hide();
		}


		DocFormv2.updateDisplayColumn(hideColumn);

		DocFormv2.getNumFormat(true);
		$('.row.computable, .row.shipping, .row.packaging', '#docForm').each(function(){
			DocFormv2.updateRow('#'+$(this).attr('id'), false);

			var discountColumn = $(this).find('.discount');
			if(checked) {
				if(discountChecked) {
					discountColumn.show();
					discountColumn.addClass(DocFormv2.columnsDisplay['discount']);
				} else {
					discountColumn.show();
				}
			} else {
				discountColumn.hide();
			}
		});
		DocFormv2.updateTotal();
	},

	displayVatNum : function() {

		if($("#showThirdVATOnPdf").is(':checked')) {
			$("#ThirdVATnumDiv").show();
		}else {
			$("#ThirdVATnumDiv").hide();
		}
	},

	defaultWarehouse : function() {
		var warehouseid = $('#defaultwarehouse').val();

		$( "select[name^='row_whid_']" ).each(function() {
			$("select[name^='row_whid_'] option[value="+warehouseid+"]").prop('selected', true);
		});

		MyWindow.alert(Loc.g('Modification appliquée.'), {
			type:'confirm'
		});
	},

	toggleMarginInfos : function() {
		var main	= $('#marginInfosChecker');
		var content = main.find('.marginContent');
		var waiting = main.find('.marginWaitingContent');
		var toggler	= main.find('.marginToggler');

		if(content.is(':visible')) {
			content.slideUp();
			waiting.slideDown();

			toggler.removeClass('fa-minus-square-o');
			toggler.addClass('fa-plus-square-o');
		} else {
			content.slideDown();
			waiting.slideUp();

			toggler.removeClass('fa-plus-square-o');
			toggler.addClass('fa-minus-square-o');
		}
	},

	toggleSettingPanel: function () {
		$("#docSettingsPanel").toggleClass("open");
		$("#docSettingsPanel").slideToggle();
		$("#docSettingsPanel").hasClass("open") ? $("#docSettingsPanelBtn").text(Loc.g("Fermer")) : $("#docSettingsPanelBtn").text(Loc.g("Ouvrir"));
	},

	deleteRows : function() {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g('Supprimer les lignes'),
			type		: 'warning',
			buttons		: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){ $(this).dialog("close"); }
				},
				{
					text	: Loc.g("Continuer"),
					click	: function(){
						DocFormv2.do_deleteRows();
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Voulez-vous vraiment supprimer toutes les lignes de ce document ?'), options);
	},

	do_deleteRows : function() {
		$('#formContent .docrow').each(function(i, val) {
			var current = $(val);
			var rowid	= (current.attr('id').split('row_'))[1];

			DocFormv2.deleteRow(rowid, false);
		});

		setTimeout(function() {
			DocFormv2.updateProductsCharacteristics();
			DocFormv2.updateTotal();
		}, 1000);
	},

	toggleMore : function(rowid) {
		var more	= $('#row_' + rowid + '_more');
		var toggler	= $('#row_' + rowid + '_toggler span');
		if(more.is(":visible")) {
			more.hide();

			toggler.removeClass('fa-caret-up');
			toggler.addClass('fa-caret-down');
		} else {
			more.show();

			toggler.addClass('fa-caret-up');
			toggler.removeClass('fa-caret-down');

			MyFacture.customForm('#row_' + rowid + '_more');
		}
	},

	alertStockEdition : function(returnUrl){

		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Informations stock"),
			type		: 'warning',
			buttons		: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						Utils.relocate(returnUrl);
					}
				},
				{
					text	: Loc.g("Ok"),
					click	: function(){
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Vous êtes sur le point de modifier un document impactant les stocks. Cette action peut entrainer des décalages dans votre inventaire.'), options);

	},

	toggleServicesDates: function(){

		var useServiceDates = $('#docForm #useServiceDates').is(':checked');

		if (useServiceDates){
			$('#docForm .servicesDatesContainer').show();
			MyFacture.customForm('#servicesDates');
		} else {
			$('#docForm .servicesDatesContainer').hide();
		}

	},

    checkOverrideTotals: function(){

        if($('[name="overrideTotals"]').is(':checked')){
            // Display Input
            $('.override-totals-editable').show();
            $('.override-totals-no-editable').hide();

        }

        // Disabled all input who override Total
        $('.overrideTotalsDataInput').prop('disabled', true);

        // And enabled it only for visible input
        $('.overrideTotalsDataInputDisplay:visible').each(function(){
            var identifier = $(this).attr('id');
            $('[name="'+identifier+'"]').prop('disabled', false);
        });

    },

    formatOverrideTotalInput: function(el){

        var amount = $(el).val();
        var amountWithoutFormat = NumberFormat.formatToFloat(amount, DocFormv2.getNumFormat())
        var identifier = $(el).attr('id');

        $('[name="'+identifier+'"]').val(amountWithoutFormat);
    },

	updateVatMode: function(bypassPref = null){
		var vatMode = $('#vatMode').val();
		var $vatMention = $('#vatMention');
		if (!this.docid && !bypassPref && vatMode === $vatMention.data('defaultvatmode')) {
			$vatMention.val($('#vatMention').data('defaultmention'));
			return;
		} else if ((this.docid || bypassPref) && vatMode === $vatMention.data('originalmode')) {
			$vatMention.val($('#vatMention').data('originalvalue'));
			return;
		}

		var messageDebit = Loc.g('TVA exigible sur les débits');
		var messageCollection = Loc.g('TVA exigible sur les encaissements');

		$vatMention.val(vatMode === 'debit' ? messageDebit : messageCollection);
	},

	/**
	 * See SAAS-26699
	 */
	roundTotalLineFlagEnabled: function() {
		return Feature.isEnabled('js-docform-round-total-line-amounts');
	}
};
